
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("9sGCn", function(module, exports) {

var $5RVp4 = parcelRequire("5RVp4");


var $5tydj = parcelRequire("5tydj");


var $kBBRP = parcelRequire("kBBRP");


var $b22Ya = parcelRequire("b22Ya");


var $2XqLN = parcelRequire("2XqLN");


var $fFmJj = parcelRequire("fFmJj");


var $ge2sX = parcelRequire("ge2sX");

var $416a341702253f60$var$Client = /*#__PURE__*/ function(Client) {
    Client["CC_GRAPHQL"] = "Cc graphql client";
    Client["AGG_GRAPHQL"] = "Agg graphql client";
    return Client;
}($416a341702253f60$var$Client || {});
const $416a341702253f60$var$FRAGMENTS_BY_TYPE = [
    {
        client: "Cc graphql client",
        gqlType: 'Content',
        fragment: (0, $b22Ya.default)
    },
    {
        client: "Cc graphql client",
        gqlType: 'Content',
        // If we don't have `status` cached but do have `subType` cached, this ensures we still fast load it. We prefer fast loading live docs even if we're uncertain whether they're archived.
        fragment: (0, $kBBRP.default)
    },
    {
        client: "Cc graphql client",
        gqlType: 'PTPage',
        fragment: (0, $5tydj.default)
    },
    {
        // Search query uses agg graphql client
        client: "Agg graphql client",
        gqlType: 'SearchConfluencePageBlogAttachment',
        fragment: (0, $5RVp4.default)
    }
];
const $416a341702253f60$export$b4dacd1dfdee469b = (0, $2XqLN.default)((contentId)=>{
    if (!contentId) // When content id does not exist, return undefined values
    return {
        subType: undefined,
        isArchived: undefined,
        gqlType: undefined
    };
    const cloudId = (0, $ge2sX.getCloudId)();
    let subType;
    let isArchived = undefined;
    let gqlTypeUsed;
    $416a341702253f60$var$FRAGMENTS_BY_TYPE.some(({ client: client, gqlType: gqlType, fragment: fragment })=>{
        // readFragment throws an error if it finds the item in the cache without both id and subtype, so we wrap in try/catch
        try {
            let id = `${gqlType}:${contentId}`;
            if (gqlType === 'SearchConfluencePageBlogAttachment') // Search graphql query includes the ARI in the id
            id = `${gqlType}:ari:cloud:confluence:${cloudId}:page/${contentId}`;
            const fragmentData = (0, $fFmJj.readFragmentInterop)({
                id: id,
                fragment: fragment,
                interopApolloAggClient: client === "Agg graphql client",
                __callerPackage__: "@confluence/live-pages-utils"
            });
            if (fragmentData && 'subType' in fragmentData && fragmentData.subType) {
                subType = fragmentData.subType;
                isArchived = 'status' in fragmentData && fragmentData.status ? fragmentData.status?.toLowerCase?.() === 'archived' : undefined;
                gqlTypeUsed = gqlType;
                return true;
            } else if (fragmentData && 'subtype' in fragmentData && fragmentData.subtype) {
                // In search graphql query's response, subtype exists as an inline fragment on ConfluencePage
                subType = fragmentData.subtype?.toLowerCase?.();
                gqlTypeUsed = gqlType;
                return true;
            }
        } catch  {}
    });
    return {
        subType: subType,
        isArchived: isArchived,
        gqlType: gqlTypeUsed
    };
});
const $416a341702253f60$export$d56c32e9e73f8f9b = ()=>$416a341702253f60$export$b4dacd1dfdee469b.clear();
module.exports["getCachedPageData"] = $416a341702253f60$export$b4dacd1dfdee469b;
module.exports["clearMemoizedCachedPageData"] = $416a341702253f60$export$d56c32e9e73f8f9b;

});

parcelRegister("5RVp4", function(module, exports) {
/**
 * @generated SignedSource<<34081095f351c632b5c7f6a48a856531>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d1b5c3b39238b90e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "getCachedPageDataSubTypeSearchFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "LinkedField",
            "name": "confluenceEntity",
            "plural": false,
            "selections": [
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "subtype"
                        }
                    ],
                    "type": "ConfluencePage"
                }
            ]
        }
    ],
    "type": "SearchConfluencePageBlogAttachment"
};
$d1b5c3b39238b90e$var$node.hash = "029b00b42bd8ba9e9b5ecf4947b241c2";
var $d1b5c3b39238b90e$export$2e2bcd8739ae039 = $d1b5c3b39238b90e$var$node;
module.exports["default"] = $d1b5c3b39238b90e$export$2e2bcd8739ae039;

});

parcelRegister("5tydj", function(module, exports) {
/**
 * @generated SignedSource<<da5cfc67a1415713a060abd033946dcb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $019558c9ca245006$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "getCachedPageDataSubTypePageTreeFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        }
    ],
    "type": "PTPage"
};
$019558c9ca245006$var$node.hash = "7ccb76f2a832d90b6f167fe96a11f5a9";
var $019558c9ca245006$export$2e2bcd8739ae039 = $019558c9ca245006$var$node;
module.exports["default"] = $019558c9ca245006$export$2e2bcd8739ae039;

});

parcelRegister("kBBRP", function(module, exports) {
/**
 * @generated SignedSource<<99bf881c6efd8312ff9d65a4878761ee>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6f66d8210bca9b3e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "getCachedPageDataSubTypeContentFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        }
    ],
    "type": "Content"
};
$6f66d8210bca9b3e$var$node.hash = "03b28a640aee18909db0a4f3575e7f08";
var $6f66d8210bca9b3e$export$2e2bcd8739ae039 = $6f66d8210bca9b3e$var$node;
module.exports["default"] = $6f66d8210bca9b3e$export$2e2bcd8739ae039;

});

parcelRegister("b22Ya", function(module, exports) {
/**
 * @generated SignedSource<<3e2b4706208bc59168d9b7bd4bd3d395>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f9170d170545992b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "getCachedPageDataContentFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        }
    ],
    "type": "Content"
};
$f9170d170545992b$var$node.hash = "b940ae3a5484e1099f106d12713d37f5";
var $f9170d170545992b$export$2e2bcd8739ae039 = $f9170d170545992b$var$node;
module.exports["default"] = $f9170d170545992b$export$2e2bcd8739ae039;

});

parcelRegister("56LFI", function(module, exports) {
async function $d3c226111d006051$var$toPromise(callback) {
    return callback();
}
function $d3c226111d006051$var$getScheduler(obj) {
    if ('scheduler' in obj && obj.scheduler !== 'undefined') return obj.scheduler;
}

function $d3c226111d006051$export$13c9d02ca54955a3(callback, options) {
    // Dynamically import the scheduler-polyfill module, so browsers that do support the Prioritized Task Scheduling API
    // do not pay the performance cost (e.g. bundle size, runtime, etc).
    const scheduler = $d3c226111d006051$var$getScheduler(globalThis);
    if (!scheduler) {
        // Only load the polyfill if we are using the background priority
        if (options.priority === 'background') // This polyfill will be removed once the Prioritized Task Scheduling API is more widely supported in browsers.
        // eslint-disable-next-line import/dynamic-import-chunkname
        // @ts-ignore error TS7016: Could not find a declaration file for module 'scheduler-polyfill' seen in Jira Typechecking (Cypress) step
        return (parcelRequire("j5M61")).then(()=>$d3c226111d006051$var$getScheduler(globalThis).postTask(callback, options));
        return $d3c226111d006051$var$toPromise(callback);
    }
    return scheduler.postTask(callback, options);
}
module.exports["postTask"] = $d3c226111d006051$export$13c9d02ca54955a3;

});

parcelRegister("j5M61", function(module, exports) {

let $de63cad6e511e9d7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $de63cad6e511e9d7$var$load("5a167").then(()=>parcelRequire('jUuBC'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("8zMP3", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $hnvzE = parcelRequire("hnvzE");


var $hZpML = parcelRequire("hZpML");


var $8zKDl = parcelRequire("8zKDl");


var $cemw8 = parcelRequire("cemw8");

// Enhanced context to track the full boundary chain from root to current
const $5cfe2edd168ef31e$var$SuspenseBoundaryNameContext = /*#__PURE__*/ (0, $42omo.createContext)([]);
const $5cfe2edd168ef31e$export$b17d024ed060ce0b = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $42omo.useContext)($5cfe2edd168ef31e$var$SuspenseBoundaryNameContext);
} : ()=>{
    return (0, $42omo.useContext)($5cfe2edd168ef31e$var$SuspenseBoundaryNameContext);
};
const $5cfe2edd168ef31e$var$SuspenseWithDataFetcherReader = (0, $3u0dr.isReactCompilerActiveV2)() ? function SuspenseWithDataFetcherReader(t0) {
    const $ = (0, $frIzR.c)(2);
    const { dataFetcher: dataFetcher, children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : function SuspenseWithDataFetcherReader({ dataFetcher: dataFetcher, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
function $5cfe2edd168ef31e$export$553ede96e278ba94({ dataFetcherName: dataFetcherName, fallback: fallback = null, children: children }) {
    // Capture the SSR streaming value on initial render using useRef
    // This ensures the component tree doesn't change when the global variable
    // is deleted during route navigation
    const isSSRStreaming = (0, $42omo.useRef)(window.__SSR_REACT_STREAMING__);
    // Get the current boundary chain from parent context
    const parentBoundaryChain = (0, $42omo.useContext)($5cfe2edd168ef31e$var$SuspenseBoundaryNameContext);
    // Create new chain by appending current boundary to parent chain
    const currentBoundaryChain = [
        ...parentBoundaryChain,
        dataFetcherName
    ];
    if (isSSRStreaming.current) {
        const dataFetcher = (0, $8zKDl.getDataFetcherForSuspense)(dataFetcherName, isSSRStreaming.current);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5cfe2edd168ef31e$var$SuspenseBoundaryNameContext.Provider, {
            value: currentBoundaryChain
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cemw8.HydrationSafeSuspense), {
            fallback: fallback
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5cfe2edd168ef31e$var$SuspenseWithDataFetcherReader, {
            dataFetcher: dataFetcher
        }, (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_SUSPENSE}/${dataFetcherName}.start`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
            name: `stream-suspense-${dataFetcherName}`
        }, children), (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_SUSPENSE}/${dataFetcherName}.end`))));
    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
}
module.exports["SuspenseWithDataFetcher"] = $5cfe2edd168ef31e$export$553ede96e278ba94;

});

parcelRegister("8zKDl", function(module, exports) {
function $2b2227915da27313$export$63116239d47be9ca(dataFetcherName, isSSRStreaming = true) {
    if (!isSSRStreaming || !dataFetcherName) return null;
    return window.__dataFetcherForSuspense__?.[dataFetcherName] ?? null;
}
module.exports["getDataFetcherForSuspense"] = $2b2227915da27313$export$63116239d47be9ca;

});

parcelRegister("cemw8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $e4o8D = parcelRequire("e4o8D");

const $28f120e398482486$var$HydrationSafeSuspenseContent = /*#__PURE__*/ (0, $42omo.memo)(function HydrationSafeSuspenseContent({ children: children, fallback: fallback }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: fallback
    }, children);
}, (_prevProps, nextProps)=>{
    // Block updates while locked (during hydration)
    return nextProps.isLocked;
});
function $28f120e398482486$export$a0bfcafd6d556141({ fallback: fallback = null, children: children }) {
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($28f120e398482486$var$HydrationSafeSuspenseContent, {
        isLocked: renderServerPlaceholder,
        fallback: fallback
    }, children);
}
module.exports["HydrationSafeSuspense"] = $28f120e398482486$export$a0bfcafd6d556141;

});

parcelRegister("eMqrF", function(module, exports) {

var $02AY0 = parcelRequire("02AY0");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/identity/team/manifest.ts
var $ac2a0fd84662e75e$var$identityTeamAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $02AY0.IdentityTeamAriResourceOwner),
    resourceType: (0, $02AY0.IdentityTeamAriResourceType),
    resourceIdSlug: "{teamId}",
    resourceIdSegmentFormats: {
        teamId: /[a-zA-Z0-9.\-_~]+/
    }
};
// src/identity/team/index.ts
var $ac2a0fd84662e75e$export$33bbb2d79e520118 = class _IdentityTeamAri extends (0, $3NXcb.RegisteredAri) {
    get teamId() {
        return this._teamId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $ac2a0fd84662e75e$var$identityTeamAriStaticOpts.qualifier,
            platformQualifier: $ac2a0fd84662e75e$var$identityTeamAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $ac2a0fd84662e75e$var$identityTeamAriStaticOpts.resourceOwner,
            resourceType: $ac2a0fd84662e75e$var$identityTeamAriStaticOpts.resourceType,
            resourceId: `${opts.teamId}`,
            resourceIdSegmentValues: {
                teamId: opts.teamId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $ac2a0fd84662e75e$var$identityTeamAriStaticOpts);
        return new _IdentityTeamAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $ac2a0fd84662e75e$var$identityTeamAriStaticOpts);
        return new _IdentityTeamAri(opts);
    }
    getVariables() {
        return {
            teamId: this.teamId
        };
    }
    constructor(opts){
        super(opts), this._teamId = opts.resourceIdSegmentValues.teamId;
    }
};
module.exports["IdentityTeamAri"] = $ac2a0fd84662e75e$export$33bbb2d79e520118;

});

parcelRegister("02AY0", function(module, exports) {
// src/identity/team/types.ts
var $007cdcdc857abd84$export$49beddf48ffb3f35 = "identity", $007cdcdc857abd84$export$b2079a2a841afe32 = "team";
module.exports["IdentityTeamAriResourceOwner"] = $007cdcdc857abd84$export$49beddf48ffb3f35;
module.exports["IdentityTeamAriResourceType"] = $007cdcdc857abd84$export$b2079a2a841afe32;

});

parcelRegister("b8JCF", function(module, exports) {

var $1VjMI = parcelRequire("1VjMI");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/jira/issue/manifest.ts
var $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $1VjMI.JiraIssueAriResourceOwner),
    resourceType: (0, $1VjMI.JiraIssueAriResourceType),
    resourceIdSlug: "{issueId}",
    resourceIdSegmentFormats: {
        issueId: /[0-9]+/
    }
};
// src/jira/issue/index.ts
var $81c3d4c7dce903d7$export$1da6808e89ee03e = class _JiraIssueAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get issueId() {
        return this._issueId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts.qualifier,
            platformQualifier: $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts.resourceOwner,
            resourceType: $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts.resourceType,
            resourceId: `${opts.issueId}`,
            resourceIdSegmentValues: {
                issueId: opts.issueId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueId: this.issueId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId;
    }
};
module.exports["JiraIssueAri"] = $81c3d4c7dce903d7$export$1da6808e89ee03e;

});

parcelRegister("1VjMI", function(module, exports) {
// src/jira/issue/types.ts
var $166a76280cbc11fa$export$665a39f1b4e29e0a = "jira", $166a76280cbc11fa$export$76beb4d0da177ad4 = "issue";
module.exports["JiraIssueAriResourceOwner"] = $166a76280cbc11fa$export$665a39f1b4e29e0a;
module.exports["JiraIssueAriResourceType"] = $166a76280cbc11fa$export$76beb4d0da177ad4;

});

parcelRegister("5JRMI", function(module, exports) {

var $ehowZ = parcelRequire("ehowZ");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/townsquare/project/manifest.ts
var $01140be010796b0a$var$townsquareProjectAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $ehowZ.TownsquareProjectAriResourceOwner),
    resourceType: (0, $ehowZ.TownsquareProjectAriResourceType),
    resourceIdSlug: "{projectUuid}",
    resourceIdSegmentFormats: {
        projectUuid: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/townsquare/project/index.ts
var $01140be010796b0a$export$41215e8d01921e7d = class _TownsquareProjectAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get projectUuid() {
        return this._projectUuid;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $01140be010796b0a$var$townsquareProjectAriStaticOpts.qualifier,
            platformQualifier: $01140be010796b0a$var$townsquareProjectAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $01140be010796b0a$var$townsquareProjectAriStaticOpts.resourceOwner,
            resourceType: $01140be010796b0a$var$townsquareProjectAriStaticOpts.resourceType,
            resourceId: `${opts.projectUuid}`,
            resourceIdSegmentValues: {
                projectUuid: opts.projectUuid
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $01140be010796b0a$var$townsquareProjectAriStaticOpts);
        return new _TownsquareProjectAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $01140be010796b0a$var$townsquareProjectAriStaticOpts);
        return new _TownsquareProjectAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            projectUuid: this.projectUuid
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._projectUuid = opts.resourceIdSegmentValues.projectUuid;
    }
};
module.exports["TownsquareProjectAri"] = $01140be010796b0a$export$41215e8d01921e7d;

});

parcelRegister("ehowZ", function(module, exports) {
// src/townsquare/project/types.ts
var $a655ae9218632ad3$export$a258bc824c789b17 = "townsquare", $a655ae9218632ad3$export$aa8900dadffaa32a = "project";
module.exports["TownsquareProjectAriResourceOwner"] = $a655ae9218632ad3$export$a258bc824c789b17;
module.exports["TownsquareProjectAriResourceType"] = $a655ae9218632ad3$export$aa8900dadffaa32a;

});

parcelRegister("ibFXh", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $eyWa4 = parcelRequire("eyWa4");


var $bSqN6 = parcelRequire("bSqN6");

const $0f4f34a4aa7da555$var$styles = {
    wrapper: "_4t3i1osq _bfhkvuon"
};
const $0f4f34a4aa7da555$export$9520f072db304aa0 = ({ children: children, testId: testId })=>{
    if ((0, $dh538.fg)('ads-panel-system-gpp')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $bSqN6.PanelContainer), {
        testId: testId,
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
        xcss: $0f4f34a4aa7da555$var$styles.wrapper,
        testId: testId,
        children: children
    });
};
module.exports["PreviewPanel"] = $0f4f34a4aa7da555$export$9520f072db304aa0;

});

parcelRegister("bSqN6", function(module, exports) {
/* panel-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

const $deb4db5194285b52$var$styles = {
    wrapper: "_4t3i1osq _bfhkvuon _1e0c1txw _2lx21bp4 _kqswh2mm",
    content: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _4t3i1osq _1tkeidpf"
}; /**
    * The PanelContainer component provides a standardized container for displaying content
    * in a side panel layout. It follows the design system patterns and integrates
    * with the navigation system for consistent styling and behavior.
    *
    * For resizable panels, use the `PanelSplitter` from `@atlaskit/navigation-system/layout/panel-splitter`
    * alongside the `Panel` slot from `@atlaskit/navigation-system/layout/panel`.
    */ 
function $deb4db5194285b52$export$7c4d2b536147788a({ children: children, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        as: "section",
        testId: testId,
        xcss: $deb4db5194285b52$var$styles.wrapper,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $deb4db5194285b52$var$styles.content,
            children: children
        })
    });
}
module.exports["PanelContainer"] = $deb4db5194285b52$export$7c4d2b536147788a;

});

parcelRegister("b61pM", function(module, exports) {
/* panel-action-group.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

const $9eb18ccb1a2e95c1$var$styles = {
    group: "_zulpu2gc _1e0c1txw _4cvr1h6o"
}; /**
    * The PanelActionGroup component provides a container for grouping
    * panel actions together with consistent spacing and layout.
    */ 
function $9eb18ccb1a2e95c1$export$9546bd4ca18522f9({ children: children, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        testId: testId,
        xcss: $9eb18ccb1a2e95c1$var$styles.group,
        children: children
    });
}
module.exports["PanelActionGroup"] = $9eb18ccb1a2e95c1$export$9546bd4ca18522f9;

});

parcelRegister("aSy6D", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $bLDb6 = parcelRequire("bLDb6");


var $4m76H = parcelRequire("4m76H");

const $dd1efdb181d94706$var$panelSystemStyles = {
    fillParent: "_4t3i1osq _1e0c1txw _2lx21bp4"
};
const $dd1efdb181d94706$export$cda5e69749e7aeee = ({ children: children, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, analyticsAttributes: analyticsAttributes, styles: consumerStyles })=>{
    const bodyRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (analyticsClient) {
            analyticsClient.sendTrackEvent({
                action: 'viewed',
                actionSubject: 'preview-panel',
                actionSubjectId: 'preview-panel-view',
                source: 'preview-panel',
                attributes: {
                    parentProduct: parentProduct,
                    panelType: panelType,
                    ...(0, $dh538.fg)('add_capacity_tab_to_the_board_horizontal_nav') || (0, $dh538.fg)('add-trigger-point-key-attribute-to-preview-panel') ? analyticsAttributes : {}
                }
            });
            // https://developer.atlassian.com/platform/analytics-pipeline/guides/deep-dive/cloud-mau/
            // Fires at most once per hour, per product.
            // Requires tenantInfo and userInfo to be set
            analyticsClient?.startUIViewedEvent();
        }
    }, [
        analyticsClient,
        parentProduct,
        panelType,
        analyticsAttributes
    ]);
    // ignoring the rule as we have so many consumers of this that we need to be able to pass in styles
    /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ const panelBodyContent = (0, $dh538.fg)('ads-panel-system-gpp') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($dd1efdb181d94706$var$panelSystemStyles.fillParent, !!consumerStyles && consumerStyles),
        ref: bodyRef,
        children: children
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)(!!consumerStyles && consumerStyles),
        ref: bodyRef,
        children: children
    }); /* eslint-enable @atlaskit/design-system/consistent-css-prop-usage */ 
    if ((0, $dh538.fg)('ads-panel-system-gpp')) {
        const wrappedBody = /*#__PURE__*/ (0, $l998X.jsx)((0, $bLDb6.PanelBody), {
            spacing: "none",
            children: panelBodyContent
        });
        if ((0, $dh538.fg)('platform_preview_panels_sniffer')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $4m76H.PreviewPanelSniffer), {
            containerRef: bodyRef,
            analyticsClient: analyticsClient,
            parentProduct: parentProduct,
            panelType: panelType,
            analyticsAttributes: analyticsAttributes,
            children: wrappedBody
        });
        return wrappedBody;
    }
    if ((0, $dh538.fg)('platform_preview_panels_sniffer')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $4m76H.PreviewPanelSniffer), {
        containerRef: bodyRef,
        analyticsClient: analyticsClient,
        parentProduct: parentProduct,
        panelType: panelType,
        analyticsAttributes: analyticsAttributes,
        children: panelBodyContent
    });
    return panelBodyContent;
};
module.exports["PreviewPanelBody"] = $dd1efdb181d94706$export$cda5e69749e7aeee;

});

parcelRegister("bLDb6", function(module, exports) {
/* panel-body.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");

const $31577ff237b5519c$var$styles = {
    body: "_1reo1wug _18m91wug _16jlkb7n _1i4qfg65",
    defaultSpacing: "_bozg1ejb _y4ti1ejb _1q51v47k _85i5ze3t"
}; /**
    * The PanelBody component provides the main content area for panels
    * with consistent styling and scroll behavior.
    */ 
function $31577ff237b5519c$export$3ac6fba5a6f84a87({ children: children, spacing: spacing = 'default', testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        testId: testId,
        xcss: (0, $1Whri.cx)($31577ff237b5519c$var$styles.body, spacing === 'default' && $31577ff237b5519c$var$styles.defaultSpacing),
        children: children
    });
}
module.exports["PanelBody"] = $31577ff237b5519c$export$3ac6fba5a6f84a87;

});

parcelRegister("4m76H", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $dh538 = parcelRequire("dh538");

const $b7ecffdf81d3e124$export$93a96f69a5c679de = ({ children: children, containerRef: containerRef, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, analyticsAttributes: analyticsAttributes })=>{
    const hasSentOverflowEventRef = (0, $42omo.useRef)(false);
    const isValidContentSizeMessage = (0, $42omo.useCallback)((event, contentSizePayload)=>{
        if (contentSizePayload.type !== 'contentSize' || typeof contentSizePayload.width !== 'number' || contentSizePayload.width <= 0 || typeof contentSizePayload.height !== 'number' || contentSizePayload.height <= 0) return false;
        const panelIframe = containerRef.current?.querySelector('iframe');
        const panelIframeWindow = panelIframe?.contentWindow;
        if (!panelIframeWindow || event.source !== panelIframeWindow) return false;
        // If both origins are known, ensure the message comes from the iframe's origin.
        if (event.origin && event.origin !== 'null' && panelIframe?.src) try {
            const iframeOrigin = new URL(panelIframe.src, window.location.href).origin;
            if (event.origin !== iframeOrigin) return false;
        } catch  {
            return false;
        }
        return true;
    }, [
        containerRef
    ]);
    const sendOverflowEvent = (0, $42omo.useCallback)(({ clientWidth: clientWidth, detectionMethod: detectionMethod, scrollWidth: scrollWidth })=>{
        if (!analyticsClient || hasSentOverflowEventRef.current) return;
        hasSentOverflowEventRef.current = true;
        const overflowPx = typeof clientWidth === 'number' && typeof scrollWidth === 'number' ? Math.max(scrollWidth - clientWidth, 0) : undefined;
        analyticsClient.sendOperationalEvent({
            action: 'detected',
            actionSubject: 'layoutOverflow',
            actionSubjectId: 'preview-panel-horizontal-overflow',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType,
                detectionMethod: detectionMethod,
                clientWidth: clientWidth,
                scrollWidth: scrollWidth,
                overflowPx: overflowPx,
                ...(0, $dh538.fg)('add_capacity_tab_to_the_board_horizontal_nav') ? analyticsAttributes : {}
            }
        });
    }, [
        analyticsClient,
        parentProduct,
        panelType,
        analyticsAttributes
    ]);
    (0, $42omo.useEffect)(()=>{
        const bodyElement = containerRef.current;
        if (!bodyElement || typeof ResizeObserver === 'undefined') return;
        const detectBodyOverflow = ()=>{
            const clientWidth = bodyElement.clientWidth;
            const scrollWidth = bodyElement.scrollWidth;
            if (scrollWidth > clientWidth) sendOverflowEvent({
                detectionMethod: 'body-observer',
                clientWidth: clientWidth,
                scrollWidth: scrollWidth
            });
        };
        detectBodyOverflow();
        const observer = new ResizeObserver(detectBodyOverflow);
        observer.observe(bodyElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        containerRef,
        sendOverflowEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        const handleMessage = (event)=>{
            const contentSizePayload = event.data;
            if (!isValidContentSizeMessage(event, contentSizePayload)) return;
            const panelIframe = containerRef.current?.querySelector('iframe');
            const iframeClientWidth = panelIframe?.clientWidth ?? 0;
            const clientWidth = iframeClientWidth > 0 ? iframeClientWidth : containerRef.current?.clientWidth;
            if (typeof clientWidth !== 'number' || contentSizePayload.width <= clientWidth) return;
            sendOverflowEvent({
                detectionMethod: 'iframe-content-size-message',
                clientWidth: clientWidth,
                scrollWidth: contentSizePayload.width
            });
        };
        return (0, $fFa3V.bind)(window, {
            type: 'message',
            listener: handleMessage
        });
    }, [
        containerRef,
        isValidContentSizeMessage,
        sendOverflowEvent
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
module.exports["PreviewPanelSniffer"] = $b7ecffdf81d3e124$export$93a96f69a5c679de;

});

parcelRegister("c8wdn", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ccHMk = parcelRequire("ccHMk");

var $1qfLF = parcelRequire("1qfLF");


var $auNCB = parcelRequire("auNCB");

const $0db3677ef8eb4d12$export$2a18e3520151503 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(({ children: children, onClick: onClick, href: href, testId: testId, target: target, rel: rel, 'aria-label': ariaLabel, 'aria-haspopup': ariaHaspopup, icon: icon, label: label, appearance: appearance = 'subtle' }, ref)=>{
    if (icon) return /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
        ref: ref,
        onClick: onClick,
        testId: testId,
        icon: icon,
        label: label || ariaLabel,
        appearance: appearance,
        "aria-haspopup": ariaHaspopup,
        isTooltipDisabled: false
    });
    if (href) return /*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
        ref: ref,
        href: href,
        onClick: onClick,
        testId: testId,
        target: target,
        rel: rel,
        "aria-label": ariaLabel,
        "aria-haspopup": ariaHaspopup,
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
        ref: ref,
        onClick: onClick,
        testId: testId,
        "aria-label": ariaLabel,
        "aria-haspopup": ariaHaspopup,
        appearance: appearance,
        children: children
    });
});
module.exports["PanelAction"] = $0db3677ef8eb4d12$export$2a18e3520151503;

});

parcelRegister("fZVub", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $920790d5dac34360$var$_default_1 = (0, $aXWIB.defineMessages)({
    previewPanelCloseButtonLabel: {
        id: "navigation.preview-panel.preview-panel-header.close-button-label",
        defaultMessage: "Close"
    },
    previewPanelExpandActionLabel: {
        id: "navigation.preview-panel.preview-panel-action-variants.preview-panel-expand.expand-action-label",
        defaultMessage: "Expand"
    },
    previewPanelNewTabActionLabel: {
        id: "navigation.preview-panel.preview-panel-action-variants.preview-panel-new-tab.new-tab-action-label",
        defaultMessage: "Open in new tab"
    },
    previewPanelMoreDropdownActionLabel: {
        id: "navigation.preview-panel.preview-panel-action-variants.preview-panel-more-dropdown.more-dropdown-action-label",
        defaultMessage: "More"
    },
    previewPanelOpenInNewWindowLabel: {
        id: "navigation.preview-panel.preview-panel-header.open-in-new-window-label",
        defaultMessage: "Open in new window"
    }
});
var $920790d5dac34360$export$2e2bcd8739ae039 = $920790d5dac34360$var$_default_1;
module.exports["default"] = $920790d5dac34360$export$2e2bcd8739ae039;

});

parcelRegister("2os6v", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1qfLF = parcelRequire("1qfLF");

var $dE1p6 = parcelRequire("dE1p6");


var $dh538 = parcelRequire("dh538");


var $c8wdn = parcelRequire("c8wdn");

const $ed5d65f9b39936d9$export$a37cb5f447b2cf16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(function PreviewPanelAction({ icon: icon, label: label, onClick: onClick, href: href, testId: testId, analyticsContext: analyticsContext }, ref) {
    if ((0, $dh538.fg)('ads-panel-system-gpp')) {
        if (analyticsContext || href) return href ? /*#__PURE__*/ (0, $l998X.jsx)((0, $dE1p6.default), {
            icon: icon,
            label: label,
            onClick: onClick,
            href: href,
            testId: testId,
            analyticsContext: analyticsContext,
            appearance: "subtle",
            target: "_blank",
            ref: ref,
            role: "button"
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
            icon: icon,
            label: label,
            onClick: onClick,
            testId: testId,
            analyticsContext: analyticsContext,
            appearance: "subtle",
            ref: ref,
            role: "button"
        });
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $c8wdn.PanelAction), {
            ref: ref,
            icon: icon,
            label: label,
            onClick: onClick,
            testId: testId,
            appearance: "subtle"
        });
    }
    return href ? /*#__PURE__*/ (0, $l998X.jsx)((0, $dE1p6.default), {
        icon: icon,
        label: label,
        onClick: onClick,
        href: href,
        testId: testId,
        analyticsContext: analyticsContext,
        appearance: "subtle",
        target: "_blank",
        ref: ref,
        role: "button"
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
        icon: icon,
        label: label,
        onClick: onClick,
        testId: testId,
        analyticsContext: analyticsContext,
        appearance: "subtle",
        ref: ref,
        role: "button"
    });
});
module.exports["PreviewPanelAction"] = $ed5d65f9b39936d9$export$a37cb5f447b2cf16;

});

parcelRegister("3ZVni", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $39XmP = parcelRequire("39XmP");


var $aXWIB = parcelRequire("aXWIB");


var $1qfLF = parcelRequire("1qfLF");


var $hmuev = parcelRequire("hmuev");


var $8tdj3 = parcelRequire("8tdj3");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $u9agA = parcelRequire("u9agA");


var $c8wdn = parcelRequire("c8wdn");

var $7uw1L = parcelRequire("7uw1L");

var $b61pM = parcelRequire("b61pM");

var $1Qo1j = parcelRequire("1Qo1j");


var $fZVub = parcelRequire("fZVub");


var $6CSXv = parcelRequire("6CSXv");

const $ce13ec86664e204c$export$e1ea1fbf111a14fe = (url, paramToRemove)=>{
    try {
        const urlObj = new URL(url);
        urlObj.searchParams.delete(paramToRemove);
        return urlObj.toString();
    } catch  {
        // If URL parsing fails, return the original URL
        return url;
    }
};
const $ce13ec86664e204c$var$styles = {
    header: "_1h6d1l7x _bozg1ejb _y4ti1ejb _1q51pxbi _85i5pxbi _12ornqa1 _1r62e4h9 _4t3i8vuz",
    childWrapper: "_16jlkb7n",
    titleRegion: "_zulpu2gc _1e0c1txw _2lx2vrvc _4cvr1h6o _1bah1yb4 _16jlkb7n _1ul9idpf"
};
const $ce13ec86664e204c$export$426d4171de44bac0 = ({ children: children, onClose: onClose, onOpenInNewTab: onOpenInNewTab, testId: testId, url: url, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, moreActions: moreActions })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const enableCrossMAUUsage = (0, $dh538.fg)('platform_preview_panels_cross_app_interaction');
    const buildUrlWithAnalyticsParams = (0, $39XmP.default)({
        bridge: 'preview-panels',
        product: parentProduct ?? 'unknown'
    });
    const onPanelClose = ()=>{
        analyticsClient?.sendTrackEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'preview-panel-close',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType
            }
        });
        onClose?.();
    };
    const onOpenInNewWindow = ()=>{
        analyticsClient?.sendTrackEvent({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'preview-panel-open-in-new-window',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType
            }
        });
        onOpenInNewTab?.();
        if (url) window.open(enableCrossMAUUsage ? buildUrlWithAnalyticsParams($ce13ec86664e204c$export$e1ea1fbf111a14fe(url, 'previewPanels')) : $ce13ec86664e204c$export$e1ea1fbf111a14fe(url, 'previewPanels'));
    };
    if ((0, $dh538.fg)('ads-panel-system-gpp')) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1Qo1j.PanelHeader), {
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $ce13ec86664e204c$var$styles.titleRegion,
                children: children
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $b61pM.PanelActionGroup), {
                children: [
                    url && /*#__PURE__*/ (0, $l998X.jsx)((0, $c8wdn.PanelAction), {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))),
                        label: formatMessage((0, $fZVub.default).previewPanelOpenInNewWindowLabel),
                        onClick: onOpenInNewWindow,
                        testId: testId && `${testId}.open-in-new-window-button`,
                        appearance: "subtle"
                    }),
                    moreActions,
                    onClose && /*#__PURE__*/ (0, $l998X.jsx)((0, $7uw1L.PanelActionClose), {
                        onClick: onPanelClose,
                        testId: testId && `${testId}.close-button`,
                        label: formatMessage((0, $fZVub.default).previewPanelCloseButtonLabel)
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        xcss: $ce13ec86664e204c$var$styles.header,
        testId: testId,
        alignBlock: "center",
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                xcss: $ce13ec86664e204c$var$styles.childWrapper,
                spread: "space-between",
                alignBlock: "center",
                space: "space.100",
                children: children
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                gap: "space.100",
                children: [
                    url && /*#__PURE__*/ (0, $l998X.jsx)((0, $6CSXv.PreviewPanelNewTabLink), {
                        label: formatMessage((0, $fZVub.default).previewPanelOpenInNewWindowLabel),
                        onClick: onOpenInNewWindow,
                        testId: testId && `${testId}.open-in-new-window-button`
                    }),
                    moreActions,
                    onClose && /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                        icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                                ...iconProps,
                                size: "small"
                            }),
                        label: formatMessage((0, $fZVub.default).previewPanelCloseButtonLabel),
                        onClick: onPanelClose,
                        testId: testId && `${testId}.close-button`,
                        role: "button"
                    })
                ]
            })
        ]
    });
};
module.exports["PreviewPanelHeader"] = $ce13ec86664e204c$export$426d4171de44bac0;

});

parcelRegister("39XmP", function(module, exports) {
$parcel$export(module.exports, "default", () => $f84bdce2dbfd750d$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $5spQU = parcelRequire("5spQU");


var $fFa3V = parcelRequire("fFa3V");


var $T9xHm = parcelRequire("T9xHm");


var $dh538 = parcelRequire("dh538");


var $a4UIB = parcelRequire("a4UIB");


var $26AWB = parcelRequire("26AWB");


var $5O1V9 = parcelRequire("5O1V9");

function $f84bdce2dbfd750d$export$2e2bcd8739ae039(options) {
    const [interactionSessionId, setInteractionSessionId] = (0, $42omo.useState)('');
    const { bridge: bridge, product: product, subProduct: subProduct } = options;
    const shouldDisable = (0, $dh538.fg)('use_frontend_feature_encoding_sdk_platform') ? !(0, $5spQU.isFeatureEnabled)('atlassian-analytics', 'atlassian-analytics-cross-product-interaction-client') : (0, $T9xHm.isFedrampModerate)();
    const isEnabled = !shouldDisable;
    // Client does not change on re-render - cache with useMemo
    const interactionSessionClient = (0, $42omo.useMemo)(()=>{
        if (isEnabled) return new (0, $a4UIB.default)();
        else return null;
    }, [
        isEnabled
    ]);
    (0, $42omo.useEffect)(()=>{
        if (interactionSessionClient && isEnabled) {
            // Fetch any initial interaction session ID
            const currentSessionId = interactionSessionClient.getCurrentInteractionSessionId();
            currentSessionId && setInteractionSessionId(currentSessionId);
            // Add event listener that subscribes to any future interaction session ID updates
            const unbind = (0, $fFa3V.bind)(document, {
                type: (0, $5O1V9.INTERACTION_SESSION_ID_UPDATED_EVENT),
                listener: ()=>{
                    const currentSessionId = interactionSessionClient.getCurrentInteractionSessionId();
                    currentSessionId && setInteractionSessionId(currentSessionId);
                }
            });
            return unbind;
        }
        return ()=>{};
    }, [
        interactionSessionClient,
        isEnabled
    ]);
    if (!isEnabled) return (url)=>url;
    return (url)=>(0, $26AWB.generateUrlWithParams)(url, bridge, interactionSessionId, product, subProduct);
}

});

parcelRegister("7uw1L", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $hmuev = parcelRequire("hmuev");


var $c8wdn = parcelRequire("c8wdn");

const $e3ce298d7a6a5bf4$export$75d0a5a5f71a1ab1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(({ onClick: onClick, onBeforeClose: onBeforeClose, testId: testId, label: label }, ref)=>{
    const handleClick = async (event, analyticsEvent)=>{
        if (onBeforeClose) {
            const canClose = await onBeforeClose();
            if (!canClose) return;
        }
        if (onClick) onClick(event, analyticsEvent);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $c8wdn.PanelAction), {
        ref: ref,
        onClick: handleClick,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
        label: label || 'Close panel',
        appearance: "default"
    });
});
module.exports["PanelActionClose"] = $e3ce298d7a6a5bf4$export$75d0a5a5f71a1ab1;

});

parcelRegister("1Qo1j", function(module, exports) {
/* panel-header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

const $b3d3267765cbc011$var$styles = {
    header: "_1h6d1l7x _bozg1ejb _y4ti1ejb _1q51utpp _85i5utpp _12ornqa1 _1r62e4h9 _4t3i1k7u _1e0c1txw _4cvr1h6o",
    headerContent: "_zulpu2gc _1e0c1txw _4cvr1h6o _1bah1yb4 _1bsb1osq"
}; /**
    * The PanelHeader component provides a standardized header area for panels
    * containing the title, actions, and other header-specific content.
    * It automatically organizes content into left (back button + title) and right (actions) sections
    * using flexbox layout. Place PanelActionGroup as the last child to position it on the right.
    */ 
function $b3d3267765cbc011$export$968713404ca1c9aa({ children: children, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        as: "header",
        testId: testId,
        xcss: $b3d3267765cbc011$var$styles.header,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
            xcss: $b3d3267765cbc011$var$styles.headerContent,
            children: children
        })
    });
}
module.exports["PanelHeader"] = $b3d3267765cbc011$export$968713404ca1c9aa;

});

parcelRegister("6CSXv", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $8tdj3 = parcelRequire("8tdj3");


var $fZVub = parcelRequire("fZVub");


var $2os6v = parcelRequire("2os6v");

const $4d61e3d7ff65f94b$export$d05dda6f1d91eaad = ({ href: href, label: label, onClick: onClick, testId: testId, analyticsContext: analyticsContext })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2os6v.PreviewPanelAction), {
        label: label || formatMessage((0, $fZVub.default).previewPanelNewTabActionLabel),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))),
        onClick: onClick,
        href: href,
        testId: testId,
        analyticsContext: analyticsContext
    });
};
module.exports["PreviewPanelNewTabLink"] = $4d61e3d7ff65f94b$export$d05dda6f1d91eaad;

});

parcelRegister("3R2u2", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");


var $6JZNk = parcelRequire("6JZNk");

const $237c600fec460668$export$92a58681483f4529 = ({ title: title, icon: icon, color: color })=>{
    if ((0, $dh538.fg)('ads-panel-system-gpp')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $6JZNk.PanelTitle), {
        icon: icon,
        children: title
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "center",
        children: [
            icon,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                weight: "bold",
                maxLines: 1,
                color: color,
                children: title
            })
        ]
    });
};
module.exports["PreviewPanelTitle"] = $237c600fec460668$export$92a58681483f4529;

});

parcelRegister("6JZNk", function(module, exports) {
/* panel-title.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $cO1el = parcelRequire("cO1el");


var $gdv5Z = parcelRequire("gdv5Z");

const $3142a015613eed0f$var$styles = {
    title: "_zulp1b66 _1e0c1txw _4cvr1h6o _16jlkb7n",
    icon: "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1tcg _4t3i1tcg"
}; /**
    * The PanelTitle component provides a standardized title display for panels
    * with optional icon support and consistent typography.
    */ 
function $3142a015613eed0f$export$86de09faaa70680d({ children: children, icon: icon, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        testId: testId,
        xcss: $3142a015613eed0f$var$styles.title,
        children: [
            icon && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $3142a015613eed0f$var$styles.icon,
                children: icon
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                size: "xsmall",
                as: "h2",
                children: children
            })
        ]
    });
}
module.exports["PanelTitle"] = $3142a015613eed0f$export$86de09faaa70680d;

});

parcelRegister("2o57A", function(module, exports) {
$parcel$export(module.exports, "useResource", () => (parcelRequire("cAkP0")).useResource);
$parcel$export(module.exports, "useRouter", () => (parcelRequire("bJu3R")).useRouter);
$parcel$export(module.exports, "createResource", () => (parcelRequire("cRWzz")).createResource);
$parcel$export(module.exports, "useRouterActions", () => (parcelRequire("bJu3R")).useRouterActions);
$parcel$export(module.exports, "createRouterSelector", () => (parcelRequire("lbfkG")).createRouterSelector);

parcelRequire("iOc92");
var $cRWzz = parcelRequire("cRWzz");
var $lbfkG = parcelRequire("lbfkG");
var $cAkP0 = parcelRequire("cAkP0");
var $bJu3R = parcelRequire("bJu3R");

parcelRequire("jtq3j");
var $9f15D = parcelRequire("9f15D");
var $crDmH = parcelRequire("crDmH");


var $eFXPq = parcelRequire("eFXPq");
var $6di1Y = parcelRequire("6di1Y");
var $cltiJ = parcelRequire("cltiJ");
var $8hLIT = parcelRequire("8hLIT");


});

parcelRegister("iOc92", function(module, exports) {
$parcel$export(module.exports, "RouterSubscriber", () => (parcelRequire("baqAE")).RouterSubscriber);
$parcel$export(module.exports, "useResource", () => (parcelRequire("cAkP0")).useResource);
$parcel$export(module.exports, "useRouter", () => (parcelRequire("bJu3R")).useRouter);
$parcel$export(module.exports, "useRouterActions", () => (parcelRequire("bJu3R")).useRouterActions);
$parcel$export(module.exports, "createResource", () => (parcelRequire("cRWzz")).createResource);
$parcel$export(module.exports, "createRouterSelector", () => (parcelRequire("lbfkG")).createRouterSelector);
parcelRequire("647sQ");
var $baqAE = parcelRequire("baqAE");


var $2U2r8 = parcelRequire("2U2r8");


var $lO3qv = parcelRequire("lO3qv");


var $dzuak = parcelRequire("dzuak");


var $d6UuE = parcelRequire("d6UuE");


var $hYD0c = parcelRequire("hYD0c");


var $dBql1 = parcelRequire("dBql1");

parcelRequire("gE0ZU");
var $cAkP0 = parcelRequire("cAkP0");
var $bJu3R = parcelRequire("bJu3R");


var $45iAl = parcelRequire("45iAl");


var $cRWzz = parcelRequire("cRWzz");


var $lbfkG = parcelRequire("lbfkG");


});

parcelRegister("647sQ", function(module, exports) {
$parcel$export(module.exports, "RouterSubscriber", () => (parcelRequire("baqAE")).RouterSubscriber);

var $69HJF = parcelRequire("69HJF");


var $baqAE = parcelRequire("baqAE");


});

parcelRegister("69HJF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cAkP0 = parcelRequire("cAkP0");

const $47b5824f4071f3bb$export$fee1a6213543bd78 = ({ children: children, resource: resource, options: options })=>{
    const result = (0, $cAkP0.useResource)(resource, options);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children(result));
};

});

parcelRegister("cAkP0", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");


var $42omo = parcelRequire("42omo");


var $45iAl = parcelRequire("45iAl");


var $lbfkG = parcelRequire("lbfkG");


var $9zUhf = parcelRequire("9zUhf");

const $9298ff9836f07a7a$export$9f6abfd74295843b = (resource, options)=>{
    const [, actions] = (0, $45iAl.useResourceActions)();
    const [, { getContext: getRouterContext }] = (0, $lbfkG.useRouterStoreStatic)(); // Dynamically generate a router subscriber based on the resource:
    // makes the component re-render only when key changes instead of
    // after every route change
    const useKey = (0, $42omo.useMemo)(()=>(0, $9zUhf.createHook)((0, $lbfkG.RouterStore), {
            selector: ({ match: match, query: query, route: route }, keyArg)=>resource.getKey(keyArg != null ? keyArg : {
                    match: match,
                    query: query,
                    route: route
                }, actions.getContext())
        }), [
        resource,
        actions
    ]);
    const key = useKey(options == null ? void 0 : options.routerContext)[0];
    const [slice] = (0, $45iAl.useResourceStore)({
        type: resource.type,
        key: key
    }); // we keep route context bound to key, so route context won't refresh
    // unless key changes. This allows refresh to be called on effect cleanup
    // or asynchronously, when route context might already have changed
    const routerContext = (0, $42omo.useMemo)(()=>(options == null ? void 0 : options.routerContext) || getRouterContext(), [
        key
    ]);
    const update = (0, $42omo.useCallback)((updater)=>{
        actions.updateResourceState(resource, routerContext, updater);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clear = (0, $42omo.useCallback)(()=>{
        actions.clearResource(resource, routerContext);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clearAll = (0, $42omo.useCallback)(()=>{
        actions.clearResource(resource);
    }, [
        resource,
        actions
    ]);
    const refresh = (0, $42omo.useCallback)(()=>{
        actions.getResourceFromRemote(resource, routerContext, {
            prefetch: false
        });
    }, [
        resource,
        routerContext,
        actions
    ]);
    return (0, $7Q5yr.default)((0, $7Q5yr.default)({}, slice), {}, {
        update: update,
        key: key,
        refresh: refresh,
        clear: clear,
        clearAll: clearAll
    });
};
module.exports["useResource"] = $9298ff9836f07a7a$export$9f6abfd74295843b;

});

parcelRegister("45iAl", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");


var $bDniu = parcelRequire("bDniu");


var $FOT9i = parcelRequire("FOT9i");

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

var $j1v0l = parcelRequire("j1v0l");

var $4HDYO = parcelRequire("4HDYO");


var $fWYgZ = parcelRequire("fWYgZ");

parcelRequire("7qPh9");
var $ei5No = parcelRequire("ei5No");
var $deyLm = parcelRequire("deyLm");
var $9lk5U = parcelRequire("9lk5U");
var $7VpYm = parcelRequire("7VpYm");
var $8CzyU = parcelRequire("8CzyU");
var $d19Yq = parcelRequire("d19Yq");
var $gxxtF = parcelRequire("gxxtF");
var $h83up = parcelRequire("h83up");
var $lhfTj = parcelRequire("lhfTj");
var $aureP = parcelRequire("aureP");
var $aUV9A = parcelRequire("aUV9A");
var $jnYO4 = parcelRequire("jnYO4");

const $2f960bad94e56de9$var$PREFETCH_MAX_AGE = 10000;
const $2f960bad94e56de9$export$3f1be494d407b77a = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   */ clearResource: (resource, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            if (routerStoreContext) {
                const key = getKey(routerStoreContext, context);
                dispatch((0, $deyLm.deleteResourceState)(type, key));
                dispatch((0, $ei5No.executeForDependents)(resource, (dependentResource)=>$2f960bad94e56de9$export$3f1be494d407b77a.clearResource(dependentResource, routerStoreContext)));
            } else dispatch((0, $deyLm.deleteResourceState)(type));
        },
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const _getState = getState(), { context: context } = _getState, resourceStoreState = (0, $bDniu.default)(_getState, [
                "context"
            ]);
            const key = getKey(routerStoreContext, context);
            const prevSlice = (0, $fWYgZ.getSliceForResource)(resourceStoreState, {
                type: type,
                key: key
            });
            const data = getNewSliceData(prevSlice.data);
            const changes = prevSlice.loading ? {
                data: data,
                error: null,
                loading: true // promise: existing value retained
            } : {
                data: data,
                error: null,
                loading: false,
                promise: Promise.resolve(data)
            };
            const newSlice = (0, $7Q5yr.default)((0, $7Q5yr.default)((0, $7Q5yr.default)({}, prevSlice), changes), {}, {
                expiresAt: (0, $d19Yq.getExpiresAt)(maxAge),
                accessedAt: (0, $8CzyU.getAccessedAt)()
            });
            dispatch((0, $deyLm.setResourceState)(type, key, newSlice)); // trigger dependent resources on change
            if (newSlice.data !== prevSlice.data) dispatch((0, $ei5No.executeForDependents)(resource, (dependentResource)=>$2f960bad94e56de9$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, {})));
        },
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   */ getResource: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const _getState2 = getState(), { context: context } = _getState2, resourceStoreState = (0, $bDniu.default)(_getState2, [
                "context"
            ]);
            const key = getKey(routerStoreContext, context);
            let cached = (0, $fWYgZ.getSliceForResource)(resourceStoreState, {
                type: type,
                key: key
            });
            if ((0, $gxxtF.shouldUseCache)(cached)) {
                if ((0, $gxxtF.isFromSsr)(cached)) {
                    const withResolvedPromise = (0, $h83up.setSsrDataPromise)(cached);
                    cached = (0, $d19Yq.setExpiresAt)(withResolvedPromise, maxAge);
                }
                cached.accessedAt = (0, $8CzyU.getAccessedAt)();
                dispatch((0, $deyLm.setResourceState)(type, key, cached));
                return cached;
            }
            return dispatch($2f960bad94e56de9$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options));
        },
    /**
   * Request a single resource and update the resource cache.
   */ getResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, getData: getData, maxAge: maxAge } = resource;
            const { prefetch: prefetch, timeout: timeout } = options;
            const _getState3 = getState(), { context: context } = _getState3, resourceStoreState = (0, $bDniu.default)(_getState3, [
                "context"
            ]);
            const key = getKey(routerStoreContext, context);
            const prevSlice = (0, $fWYgZ.getSliceForResource)(resourceStoreState, {
                type: type,
                key: key
            }); // abort request if already in flight
            if (prevSlice.loading) return prevSlice;
            dispatch((0, $jnYO4.validateLRUCache)(resource, key)); // hard errors in dependencies or getData are converted into softer async error
            let promiseOrData;
            try {
                promiseOrData = getData((0, $7Q5yr.default)((0, $7Q5yr.default)({}, routerStoreContext), {}, {
                    isPrefetch: !!prefetch,
                    dependencies: dispatch((0, $ei5No.getDependencies)(resource, routerStoreContext))
                }), context);
            } catch (error) {
                promiseOrData = Promise.reject(error);
            }
            let resolvedSlice;
            if (promiseOrData === prevSlice.data) // same data (by reference) means nothing has changed and we can avoid loading state
            resolvedSlice = {};
            else {
                // ensure the promise includes any timeout error
                const timeoutGuard = timeout ? (0, $7VpYm.generateTimeGuard)(timeout) : null;
                const promise = timeout ? Promise.race([
                    promiseOrData,
                    timeoutGuard == null ? void 0 : timeoutGuard.promise
                ]).then((maybeData)=>{
                    if (timeoutGuard && !timeoutGuard.isPending) throw new (0, $lhfTj.TimeoutError)(type);
                    (timeoutGuard == null ? void 0 : timeoutGuard.timerId) && clearTimeout(timeoutGuard.timerId);
                    return maybeData;
                }) : (0, $aureP.toPromise)(promiseOrData); // enter loading state
                dispatch((0, $deyLm.setResourceState)(type, key, (0, $7Q5yr.default)((0, $7Q5yr.default)({}, prevSlice), {}, {
                    data: maxAge === 0 ? null : prevSlice.data,
                    error: maxAge === 0 ? null : prevSlice.error,
                    loading: true,
                    promise: promise,
                    accessedAt: (0, $8CzyU.getAccessedAt)(),
                    // prevent resource from being cleaned prematurely and trigger more network requests.
                    expiresAt: options.prefetch ? (0, $d19Yq.getExpiresAt)($2f960bad94e56de9$var$PREFETCH_MAX_AGE) : prevSlice.expiresAt
                }))); // trigger dependent resources to also load
                dispatch((0, $ei5No.executeForDependents)(resource, (dependentResource)=>$2f960bad94e56de9$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, options))); // in case another action occurred while loading promise may not be the one we started with
                // we need to re-assign promise consistent with error/data that we are assigning here
                try {
                    const data = await promise;
                    resolvedSlice = {
                        data: data,
                        error: null,
                        // any existing error is cleared
                        loading: false,
                        promise: promise
                    };
                } catch (error) {
                    if (error instanceof (0, $lhfTj.TimeoutError)) resolvedSlice = {
                        error: // data: do not replace existing data
                        error,
                        loading: true,
                        // this condition cannot recover so must only be present in static/server router
                        promise: null // special case for timeout
                    };
                    else resolvedSlice = {
                        error: // data: do not replace existing data
                        error,
                        loading: false,
                        promise: promise
                    };
                }
            }
            const finalSlice = (0, $7Q5yr.default)((0, $7Q5yr.default)((0, $7Q5yr.default)({}, (0, $fWYgZ.getSliceForResource)(getState(), {
                type: type,
                key: key
            })), resolvedSlice), {}, {
                accessedAt: (0, $8CzyU.getAccessedAt)(),
                expiresAt: (0, $d19Yq.getExpiresAt)(options.prefetch && maxAge < $2f960bad94e56de9$var$PREFETCH_MAX_AGE ? $2f960bad94e56de9$var$PREFETCH_MAX_AGE : maxAge)
            });
            if (dispatch((0, $deyLm.getResourceState)(type, key))) dispatch((0, $deyLm.setResourceState)(type, key, finalSlice));
            return finalSlice;
        }
};
const $2f960bad94e56de9$export$e324594224ef24da = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   * Execute such that dependencies on current route will be cleared.
   */ clearResource: (resource, routerStoreContext)=>(0, $ei5No.actionWithDependencies)(routerStoreContext == null ? void 0 : routerStoreContext.route.resources, resource, $2f960bad94e56de9$export$3f1be494d407b77a.clearResource(resource, routerStoreContext != null ? routerStoreContext : null)),
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   * Execute such that dependencies on current route will be updated.
   */ updateResourceState: (resource, routerStoreContext, ...args)=>(0, $ei5No.actionWithDependencies)(routerStoreContext.route.resources, resource, $2f960bad94e56de9$export$3f1be494d407b77a.updateResourceState(resource, routerStoreContext, ...args)),
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   * Execute such that dependencies on current route will be updated.
   */ getResource: (resource, routerStoreContext, ...args)=>(0, $ei5No.actionWithDependencies)(routerStoreContext.route.resources, resource, $2f960bad94e56de9$export$3f1be494d407b77a.getResource(resource, routerStoreContext, ...args)),
    /**
   * Request a single resource and update the resource cache.
   * Execute such that dependencies on current route will be updated.
   */ getResourceFromRemote: (resource, routerStoreContext, ...args)=>(0, $ei5No.actionWithDependencies)(routerStoreContext.route.resources, resource, $2f960bad94e56de9$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, ...args)),
    /**
   * Request all resources.
   */ requestAllResources: (routerStoreContext, options)=>({ dispatch: dispatch })=>{
            const { route: route } = routerStoreContext || {};
            if (!route || !route.resources) return Promise.all([]);
            return Promise.all(dispatch($2f960bad94e56de9$export$e324594224ef24da.requestResources(route.resources, routerStoreContext, options || {})));
        },
    /**
   * Cleans expired resources and resets them back to their initial state.
   * We need to do this when transitioning into a route.
   */ cleanExpiredResources: (resources, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { context: resourceContext } = getState();
            resources.forEach((resource)=>{
                const { type: type, getKey: getKey } = resource;
                const key = getKey(routerStoreContext, resourceContext);
                const slice = dispatch((0, $deyLm.getResourceState)(type, key));
                if (slice && (!slice.expiresAt || slice.expiresAt < Date.now())) dispatch((0, $deyLm.deleteResourceState)(type, key));
            });
        },
    /**
   * Requests a specific set of resources.
   */ requestResources: (resources, routerStoreContext, options)=>{
        var _routerStoreContext$r;
        const predicate = options.isStatic ? ({ isBrowserOnly: isBrowserOnly })=>!isBrowserOnly : ()=>true;
        return (0, $ei5No.mapActionWithDependencies)((_routerStoreContext$r = routerStoreContext.route.resources) == null ? void 0 : _routerStoreContext$r.filter(predicate), resources.filter(predicate), (resource)=>$2f960bad94e56de9$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options));
    },
    /**
   * Hydrates the store with state.
   * Will not override pre-hydrated state.
   */ hydrate: ({ resourceData: resourceData, resourceContext: resourceContext })=>({ getState: getState, setState: setState })=>{
            const { data: data, context: context } = getState();
            function getNextStateValue(prev, next) {
                if (!Object.keys(prev).length && next && Object.keys(next).length) return next;
                return prev;
            }
            const hydratedData = (0, $aUV9A.transformData)(getNextStateValue(data, resourceData), (_ref)=>{
                let { error: error, expiresAt: expiresAt, loading: loading } = _ref, rest = (0, $bDniu.default)(_ref, [
                    "error",
                    "expiresAt",
                    "loading"
                ]);
                const deserializedError = !error ? null : (0, $9lk5U.deserializeError)(error);
                const isTimeoutError = (deserializedError == null ? void 0 : deserializedError.name) === 'TimeoutError';
                return (0, $7Q5yr.default)((0, $7Q5yr.default)({}, rest), {}, {
                    expiresAt: isTimeoutError ? Date.now() - 1 : expiresAt,
                    loading: isTimeoutError ? false : loading,
                    error: deserializedError
                });
            });
            setState({
                data: hydratedData,
                context: getNextStateValue(context, resourceContext)
            });
        },
    /**
   * Gets the store's context
   */ getContext: ()=>({ getState: getState })=>getState().context,
    /**
   * Returns safe, portable and rehydratable data.
   */ getSafeData: ()=>({ getState: getState })=>(0, $aUV9A.transformData)(getState().data, ({ data: data, key: key, error: error, loading: loading })=>({
                    data: data,
                    key: key,
                    promise: null,
                    expiresAt: null,
                    accessedAt: null,
                    error: !error ? null : (0, $9lk5U.serializeError)(error instanceof Error ? error : new Error(JSON.stringify(error))),
                    loading: error instanceof (0, $lhfTj.TimeoutError) ? loading : false
                }))
};
const $2f960bad94e56de9$export$94f50dade551bd01 = (0, $1P1Tu.createStore)({
    initialState: {
        data: {},
        context: {},
        executing: null
    },
    actions: $2f960bad94e56de9$export$e324594224ef24da,
    name: 'router-resources'
});
const $2f960bad94e56de9$export$cc90fb9c37c5589d = (0, $FOT9i.createContainer)($2f960bad94e56de9$export$94f50dade551bd01, {
    displayName: 'ResourceContainer'
});
const $2f960bad94e56de9$export$303d1e2fcdeb1c96 = (0, $j1v0l.createSubscriber)($2f960bad94e56de9$export$94f50dade551bd01, {
    selector: null
});
const $2f960bad94e56de9$export$fee1a6213543bd78 = (0, $j1v0l.createSubscriber)($2f960bad94e56de9$export$94f50dade551bd01, {
    displayName: 'ResourceSelectorSubscriber',
    selector: (state, props)=>(0, $fWYgZ.getSliceForResource)(state, {
            type: props.resourceType,
            key: props.resourceKey
        })
});
const $2f960bad94e56de9$export$6f6057d42352becb = ()=>(0, $4HDYO.defaultRegistry).getStore($2f960bad94e56de9$export$94f50dade551bd01);
const $2f960bad94e56de9$export$ac3608e0bb357c7 = (0, $9zUhf.createHook)($2f960bad94e56de9$export$94f50dade551bd01, {
    selector: (0, $fWYgZ.getSliceForResource)
});
const $2f960bad94e56de9$export$e59f52df235ac7b3 = (0, $9zUhf.createHook)($2f960bad94e56de9$export$94f50dade551bd01, {
    selector: (0, $fWYgZ.getResourceStoreContext)
});
const $2f960bad94e56de9$export$aad2d56ed8b14bdf = (0, $9zUhf.createHook)($2f960bad94e56de9$export$94f50dade551bd01, {
    selector: null
});
module.exports["getResourceStore"] = $2f960bad94e56de9$export$6f6057d42352becb;
module.exports["useResourceStore"] = $2f960bad94e56de9$export$ac3608e0bb357c7;
module.exports["useResourceActions"] = $2f960bad94e56de9$export$aad2d56ed8b14bdf;

});

parcelRegister("fWYgZ", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");

parcelRequire("7qPh9");
var $lHZn1 = parcelRequire("lHZn1");

const $b9cb06c4546aabde$export$c9ed509724feb827 = (state, props)=>{
    const { type: type, key: key } = props;
    const slice = state.data[type] && state.data[type][key];
    return slice ? (0, $7Q5yr.default)({}, slice) : (0, $lHZn1.getDefaultStateSlice)();
};
const $b9cb06c4546aabde$export$6a0b1779210de0ee = (state)=>state.context;
module.exports["getSliceForResource"] = $b9cb06c4546aabde$export$c9ed509724feb827;
module.exports["getResourceStoreContext"] = $b9cb06c4546aabde$export$6a0b1779210de0ee;

});

parcelRegister("7qPh9", function(module, exports) {
$parcel$export(module.exports, "shouldUseCache", () => (parcelRequire("gxxtF")).shouldUseCache);
$parcel$export(module.exports, "isFromSsr", () => (parcelRequire("gxxtF")).isFromSsr);
$parcel$export(module.exports, "getDefaultStateSlice", () => (parcelRequire("lHZn1")).getDefaultStateSlice);
$parcel$export(module.exports, "getExpiresAt", () => (parcelRequire("d19Yq")).getExpiresAt);
$parcel$export(module.exports, "setExpiresAt", () => (parcelRequire("d19Yq")).setExpiresAt);
$parcel$export(module.exports, "getAccessedAt", () => (parcelRequire("8CzyU")).getAccessedAt);
$parcel$export(module.exports, "getResourcesForNextLocation", () => (parcelRequire("8vD5e")).getResourcesForNextLocation);
$parcel$export(module.exports, "generateTimeGuard", () => (parcelRequire("7VpYm")).generateTimeGuard);
$parcel$export(module.exports, "serializeError", () => (parcelRequire("9lk5U")).serializeError);
$parcel$export(module.exports, "deserializeError", () => (parcelRequire("9lk5U")).deserializeError);
$parcel$export(module.exports, "transformData", () => (parcelRequire("aUV9A")).transformData);
$parcel$export(module.exports, "TimeoutError", () => (parcelRequire("lhfTj")).TimeoutError);
$parcel$export(module.exports, "setSsrDataPromise", () => (parcelRequire("h83up")).setSsrDataPromise);
$parcel$export(module.exports, "validateLRUCache", () => (parcelRequire("jnYO4")).validateLRUCache);
$parcel$export(module.exports, "deleteResourceState", () => (parcelRequire("deyLm")).deleteResourceState);
$parcel$export(module.exports, "getResourceState", () => (parcelRequire("deyLm")).getResourceState);
$parcel$export(module.exports, "setResourceState", () => (parcelRequire("deyLm")).setResourceState);
$parcel$export(module.exports, "actionWithDependencies", () => (parcelRequire("ei5No")).actionWithDependencies);
$parcel$export(module.exports, "mapActionWithDependencies", () => (parcelRequire("ei5No")).mapActionWithDependencies);
$parcel$export(module.exports, "executeForDependents", () => (parcelRequire("ei5No")).executeForDependents);
$parcel$export(module.exports, "getDependencies", () => (parcelRequire("ei5No")).getDependencies);
$parcel$export(module.exports, "toPromise", () => (parcelRequire("aureP")).toPromise);

var $gxxtF = parcelRequire("gxxtF");


var $lHZn1 = parcelRequire("lHZn1");


var $d19Yq = parcelRequire("d19Yq");


var $8CzyU = parcelRequire("8CzyU");


var $27LN3 = parcelRequire("27LN3");


var $8vD5e = parcelRequire("8vD5e");


var $7VpYm = parcelRequire("7VpYm");


var $9lk5U = parcelRequire("9lk5U");


var $aUV9A = parcelRequire("aUV9A");


var $iNlBt = parcelRequire("iNlBt");


var $lhfTj = parcelRequire("lhfTj");


var $h83up = parcelRequire("h83up");


var $jnYO4 = parcelRequire("jnYO4");


var $deyLm = parcelRequire("deyLm");


var $ei5No = parcelRequire("ei5No");


var $aureP = parcelRequire("aureP");


});

parcelRegister("gxxtF", function(module, exports) {
const $c0a9b258007544c2$export$b25d2963b8a3488a = ({ expiresAt: expiresAt })=>expiresAt === null;
const $c0a9b258007544c2$var$isFresh = (resource)=>{
    if ($c0a9b258007544c2$export$b25d2963b8a3488a(resource)) return true;
    return Date.now() < Number(resource.expiresAt);
};
const $c0a9b258007544c2$export$399de8c43d0ece3c = (resource)=>{
    var _resource$error;
    if ((resource == null ? void 0 : (_resource$error = resource.error) == null ? void 0 : _resource$error.name) === 'TimeoutError') return false;
    if (resource.loading) return true;
    if ($c0a9b258007544c2$var$isFresh(resource)) return true;
    return false;
};
module.exports["isFromSsr"] = $c0a9b258007544c2$export$b25d2963b8a3488a;
module.exports["shouldUseCache"] = $c0a9b258007544c2$export$399de8c43d0ece3c;

});

parcelRegister("lHZn1", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");


var $4A54b = parcelRequire("4A54b");


var $d19Yq = parcelRequire("d19Yq");


var $8CzyU = parcelRequire("8CzyU");

const $fcdd38004c844b14$export$fa8e33c3301e2e94 = ()=>(0, $7Q5yr.default)((0, $7Q5yr.default)({}, (0, $4A54b.BASE_DEFAULT_STATE_SLICE)), {}, {
        expiresAt: (0, $d19Yq.getExpiresAt)((0, $4A54b.DEFAULT_RESOURCE_MAX_AGE)),
        accessedAt: (0, $8CzyU.getAccessedAt)()
    });
module.exports["getDefaultStateSlice"] = $fcdd38004c844b14$export$fa8e33c3301e2e94;

});

parcelRegister("4A54b", function(module, exports) {
const $355e744e571b7c91$export$12c1dc38ea1692da = 0;
const $355e744e571b7c91$export$881d135f98d8d7d0 = 100;
const $355e744e571b7c91$export$9ab5bdcb8a1d6c34 = false;
const $355e744e571b7c91$export$2df85a734ff5ed27 = {
    data: null,
    error: null,
    loading: false,
    promise: null
};
module.exports["DEFAULT_RESOURCE_MAX_AGE"] = $355e744e571b7c91$export$12c1dc38ea1692da;
module.exports["DEFAULT_CACHE_MAX_LIMIT"] = $355e744e571b7c91$export$881d135f98d8d7d0;
module.exports["DEFAULT_RESOURCE_BROWSER_ONLY"] = $355e744e571b7c91$export$9ab5bdcb8a1d6c34;
module.exports["BASE_DEFAULT_STATE_SLICE"] = $355e744e571b7c91$export$2df85a734ff5ed27;

});

parcelRegister("d19Yq", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");

const $97a31aec4ef49a18$export$b65d7ba7fbf150f1 = (maxAge)=>Date.now() + maxAge;
const $97a31aec4ef49a18$export$18d1d420fd588368 = (slice, maxAge)=>slice.expiresAt === null ? (0, $7Q5yr.default)((0, $7Q5yr.default)({}, slice), {}, {
        expiresAt: $97a31aec4ef49a18$export$b65d7ba7fbf150f1(maxAge)
    }) : slice;
module.exports["getExpiresAt"] = $97a31aec4ef49a18$export$b65d7ba7fbf150f1;
module.exports["setExpiresAt"] = $97a31aec4ef49a18$export$18d1d420fd588368;

});

parcelRegister("8CzyU", function(module, exports) {
const $646d7536cb54ab0f$export$9ccb639b7a119f61 = ()=>Date.now();
module.exports["getAccessedAt"] = $646d7536cb54ab0f$export$9ccb639b7a119f61;

});

parcelRegister("27LN3", function(module, exports) {
const $18c14e5b0a5cd07c$export$c616b176adf9ad4a = (resource, routerStoreContext, resourceStoreContext)=>{
    const { type: type, getKey: getKey } = resource;
    const key = getKey(routerStoreContext, resourceStoreContext);
    return `${type}/${key}`;
};
const $18c14e5b0a5cd07c$export$cd7fbe7e979df558 = (resources, routerStoreContext, resourceStoreContext)=>resources.map((resource)=>$18c14e5b0a5cd07c$export$c616b176adf9ad4a(resource, routerStoreContext, resourceStoreContext));
module.exports["getResourceIdentifier"] = $18c14e5b0a5cd07c$export$c616b176adf9ad4a;
module.exports["getResourceIdentifiers"] = $18c14e5b0a5cd07c$export$cd7fbe7e979df558;

});

parcelRegister("8vD5e", function(module, exports) {

var $27LN3 = parcelRequire("27LN3");


var $iNlBt = parcelRequire("iNlBt");

const $631f891f78d4b883$export$7cbbc763e2f3d65d = (prevRouterStoreContext, nextRouterStoreContext, resourceStoreContext)=>{
    const { route: prevRoute } = prevRouterStoreContext;
    const { resources: prevResources = [] } = prevRoute || {};
    const { route: nextRoute } = nextRouterStoreContext;
    const { resources: nextResources = [] } = nextRoute || {};
    if (!(0, $iNlBt.routeHasResources)(nextRoute)) return [];
    if ((0, $iNlBt.routeHasChanged)(prevRoute, nextRoute)) return nextResources;
    const prevResourceIdentifiers = (0, $27LN3.getResourceIdentifiers)(prevResources, prevRouterStoreContext, resourceStoreContext);
    return nextResources.filter((resource)=>!prevResourceIdentifiers.includes((0, $27LN3.getResourceIdentifier)(resource, nextRouterStoreContext, resourceStoreContext)));
};
module.exports["getResourcesForNextLocation"] = $631f891f78d4b883$export$7cbbc763e2f3d65d;

});

parcelRegister("iNlBt", function(module, exports) {
const $daed8f953cbdede5$export$740886389191c640 = (route)=>!!(route && route.resources && route.resources.length > 0);
const $daed8f953cbdede5$export$221027ff1aa38f82 = (prev, next)=>prev.name !== next.name || prev.path !== next.path;
module.exports["routeHasResources"] = $daed8f953cbdede5$export$740886389191c640;
module.exports["routeHasChanged"] = $daed8f953cbdede5$export$221027ff1aa38f82;

});

parcelRegister("7VpYm", function(module, exports) {
const $5c5200e8475ab30c$export$58634b3a58ae66b7 = (duration)=>{
    const promiseState = {
        timerId: null,
        isPending: true,
        promise: undefined
    };
    promiseState.promise = new Promise((r)=>{
        const timerId = setTimeout(()=>{
            promiseState.isPending = false;
            r();
        }, duration);
        promiseState.timerId = timerId;
    });
    return promiseState;
};
module.exports["generateTimeGuard"] = $5c5200e8475ab30c$export$58634b3a58ae66b7;

});

parcelRegister("9lk5U", function(module, exports) {
// NOTE! This has been copy pasted from https://github.com/sindresorhus/serialize-error/blob/master/index.js
// When the router moves to its own package, this must become a dependency
// For now, we have put it here so that we don't need to get it included in Jira's vendor bundle
class $6cd5a9876d4a8292$var$NonError extends Error {
    constructor(message){
        super(message);
        this.name = 'NonError';
        if (Error.captureStackTrace) Error.captureStackTrace(this, $6cd5a9876d4a8292$var$NonError);
    }
}
const $6cd5a9876d4a8292$var$commonProperties = [
    'name',
    'message',
    'stack',
    'code'
];
const $6cd5a9876d4a8292$var$destroyCircular = (from, seen, to_)=>{
    const to = to_ || (Array.isArray(from) ? [] : {});
    seen.push(from);
    for (const [key, value] of Object.entries(from)){
        if (typeof value === 'function') continue;
        if (!value || typeof value !== 'object') {
            to[key] = value;
            continue;
        }
        if (!seen.includes(from[key])) {
            to[key] = $6cd5a9876d4a8292$var$destroyCircular(from[key], seen.slice());
            continue;
        }
        to[key] = '[Circular]';
    }
    for (const property of $6cd5a9876d4a8292$var$commonProperties)if (typeof from[property] === 'string') to[property] = from[property];
    return to;
}; // const serializeError = <ErrorType = any>(value: ErrorType) => {
const $6cd5a9876d4a8292$export$46ff38bc6bdea8fb = (value)=>{
    if (typeof value === 'object' && value !== null) return $6cd5a9876d4a8292$var$destroyCircular(value, []);
     // People sometimes throw things besides Error objects…
    if (typeof value === 'function') // `JSON.stringify()` discards functions. We do too, unless a function is thrown directly.
    return `[Function: ${value.name || 'anonymous'}]`;
    return value;
};
const $6cd5a9876d4a8292$export$64cddc1e268e9046 = (value)=>{
    if (value instanceof Error) return value;
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        const newError = new Error();
        $6cd5a9876d4a8292$var$destroyCircular(value, [], newError);
        return newError;
    }
    return new $6cd5a9876d4a8292$var$NonError(value);
};
module.exports["serializeError"] = $6cd5a9876d4a8292$export$46ff38bc6bdea8fb;
module.exports["deserializeError"] = $6cd5a9876d4a8292$export$64cddc1e268e9046;

});

parcelRegister("aUV9A", function(module, exports) {
const $7f2b77e13b81d37b$export$3ceb62baab058c6b = (data, transformer)=>Object.keys(data).reduce((acc, type)=>{
        if (!acc[type]) acc[type] = {};
        Object.keys(data[type]).forEach((key)=>{
            const slice = data[type][key];
            acc[type][key] = transformer(slice);
        });
        return acc;
    }, {});
module.exports["transformData"] = $7f2b77e13b81d37b$export$3ceb62baab058c6b;

});

parcelRegister("lhfTj", function(module, exports) {
class $f7d7832b81b6fa0c$export$66d311bf29d5c89c extends Error {
    constructor(message){
        super('Resource timed out: ' + message);
        this.name = 'TimeoutError';
    }
}
module.exports["TimeoutError"] = $f7d7832b81b6fa0c$export$66d311bf29d5c89c;

});

parcelRegister("h83up", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");

const $c785e3f62ef91faf$export$2e4da1b414980956 = (slice)=>slice.promise === null ? (0, $7Q5yr.default)((0, $7Q5yr.default)({}, slice), {}, {
        promise: Promise.resolve(slice.data)
    }) : slice;
module.exports["setSsrDataPromise"] = $c785e3f62ef91faf$export$2e4da1b414980956;

});

parcelRegister("jnYO4", function(module, exports) {

var $deyLm = parcelRequire("deyLm");

const $e1cf5534dfddfb9c$export$65824bf86829963 = (routeResourceDataForType, currentKey)=>Object.keys(routeResourceDataForType).filter((resourceDataKey)=>{
        const { [resourceDataKey]: { expiresAt: expiresAt } } = routeResourceDataForType;
        return resourceDataKey !== currentKey && expiresAt && expiresAt <= Date.now();
    });
const $e1cf5534dfddfb9c$export$6288d3096045088f = (maxCache, resourceDataForType, currentKey)=>{
    if (maxCache === Infinity || maxCache < 1) return null;
    const resourceDataKeys = Object.keys(resourceDataForType);
    if (resourceDataKeys.length < maxCache) return null;
    const expiredResourceDataKeys = $e1cf5534dfddfb9c$export$65824bf86829963(resourceDataForType, currentKey);
    if (expiredResourceDataKeys.length > 0) return expiredResourceDataKeys[0];
    return resourceDataKeys.reduce((leastRecentKey, key)=>{
        const { [key]: { accessedAt: accessedAt }, [leastRecentKey]: { accessedAt: leastRecentAccessedAt } } = resourceDataForType;
        if (accessedAt && leastRecentAccessedAt && accessedAt < leastRecentAccessedAt) return key;
        return leastRecentKey;
    }, resourceDataKeys[0]);
};
const $e1cf5534dfddfb9c$export$89440b7623c2c75c = (resource, key)=>({ getState: getState, dispatch: dispatch })=>{
        const { type: type, maxCache: maxCache } = resource;
        const { data: { [type]: resourceDataForType } } = getState();
        if (!resourceDataForType) return;
        const keyTobeDeleted = $e1cf5534dfddfb9c$export$6288d3096045088f(maxCache, resourceDataForType, key);
        if (!keyTobeDeleted) return;
        dispatch((0, $deyLm.deleteResourceState)(type, keyTobeDeleted));
    };
module.exports["validateLRUCache"] = $e1cf5534dfddfb9c$export$89440b7623c2c75c;

});

parcelRegister("deyLm", function(module, exports) {

var $bDniu = parcelRequire("bDniu");


var $7Q5yr = parcelRequire("7Q5yr");

function $9a278c54b2abcdf6$var$_toPropertyKey(arg) {
    var key = $9a278c54b2abcdf6$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $9a278c54b2abcdf6$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
const $9a278c54b2abcdf6$export$704f800f263b050e = (type, key, state)=>({ setState: setState, getState: getState })=>{
        const { data: data } = getState();
        setState({
            data: (0, $7Q5yr.default)((0, $7Q5yr.default)({}, data), {}, {
                [type]: (0, $7Q5yr.default)((0, $7Q5yr.default)({}, data[type] || {}), {}, {
                    [key]: state
                })
            })
        });
    };
const $9a278c54b2abcdf6$export$5fc90c33b03fffb = (type, key)=>({ getState: getState })=>{
        const { data: { [type]: resourceDataForType } } = getState();
        return resourceDataForType == null ? void 0 : resourceDataForType[key];
    };
const $9a278c54b2abcdf6$export$d40f35dc5952864b = (type, key)=>({ getState: getState, setState: setState })=>{
        const { data: data } = getState();
        const { [type]: resourceForType } = data, remainingData = (0, $bDniu.default)(data, [
            type
        ].map($9a278c54b2abcdf6$var$_toPropertyKey));
        if (key === undefined) setState({
            data: remainingData
        });
        else if (resourceForType) {
            const remainingForType = (0, $bDniu.default)(resourceForType, [
                key
            ].map($9a278c54b2abcdf6$var$_toPropertyKey));
            setState({
                data: (0, $7Q5yr.default)((0, $7Q5yr.default)({}, remainingData), {}, {
                    [type]: remainingForType
                })
            });
        }
    };
module.exports["setResourceState"] = $9a278c54b2abcdf6$export$704f800f263b050e;
module.exports["getResourceState"] = $9a278c54b2abcdf6$export$5fc90c33b03fffb;
module.exports["deleteResourceState"] = $9a278c54b2abcdf6$export$d40f35dc5952864b;

});

parcelRegister("ei5No", function(module, exports) {

var $fWYgZ = parcelRequire("fWYgZ");

var $a6773e0103928585$var$_Object$fromEntries;
const $a6773e0103928585$var$fromEntries = ($a6773e0103928585$var$_Object$fromEntries = Object.fromEntries) != null ? $a6773e0103928585$var$_Object$fromEntries : (entries)=>Object.assign({}, ...entries.map(([k, v])=>({
            [k]: v
        })));
const $a6773e0103928585$var$matchType = (a)=>(b)=>{
        const [{ type: typeA }] = Array.isArray(a) ? a : [
            a
        ];
        const [{ type: typeB }] = Array.isArray(b) ? b : [
            b
        ];
        return typeA === typeB;
    };
class $a6773e0103928585$export$492ad57edfe1e919 extends Error {
    constructor(message){
        super(message);
        this.name = 'ResourceDependencyError';
    }
}
const $a6773e0103928585$export$12600f2e0e7fb2cc = (routeResources, tuples)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        var _routeResources$some;
        if (getState().executing) throw new Error('execution is already in progress');
         // check if there are resources and if so if there are any resources with dependencies
        const hasDependentResources = (_routeResources$some = routeResources == null ? void 0 : routeResources.some(({ depends: depends })=>depends == null ? void 0 : depends.length)) != null ? _routeResources$some : false;
        if (!hasDependentResources) return tuples.map(([, action])=>dispatch(action));
         // some resources might not be listed on the route resources so must be dispatched separate from executing state
        const listedTuples = tuples.filter(([resource])=>routeResources == null ? void 0 : routeResources.some($a6773e0103928585$var$matchType(resource)));
        if (listedTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
         // accumulate the dependency types for all executing resources
        // find downstream resources that may also execute and include their dependencies too
        // include the resource type as well in the list
        // we don't validate that these are legal dependencies
        const [dependentTypes] = routeResources.reduce((acc, { type: type, depends: depends })=>{
            const [dependencies, executableTypes] = acc;
            const isExecutable = executableTypes.includes(type) || !!(depends == null ? void 0 : depends.some((dependency)=>executableTypes.includes(dependency)));
            return isExecutable ? [
                depends ? [
                    ...dependencies,
                    ...depends,
                    type
                ] : dependencies,
                [
                    ...executableTypes,
                    type
                ]
            ] : acc;
        }, [
            [],
            listedTuples.map(([{ type: type }])=>type)
        ]).filter((v, i, a)=>a.indexOf(v) === i); // resources that are completely independent are preferable to be dispatched separate from executing state
        const dependentTuples = listedTuples.filter(([{ type: type }])=>dependentTypes.includes(type));
        if (dependentTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
         // additionally find all direct dependencies of these executing or possibly executing resources
        // we don't validate that these are legal dependencies
        const dependentAndDependencyTypes = routeResources.filter(({ type: type })=>dependentTypes.includes(type)).reduce((acc, { type: type, depends: depends })=>depends ? [
                ...acc,
                ...depends,
                type
            ] : [
                ...acc,
                type
            ], []).filter((v, i, a)=>a.indexOf(v) === i); // setup executing tuples in route resource order
        // this state allows actions to call executeForDependents() to influence actions that follow
        // the list includes dependency resources so that getDependencies() may validate without needing route resources
        // we use the resource definition of the given tuple where present or otherwise the definition from route resources
        const executingTuples = routeResources.filter(({ type: type })=>dependentAndDependencyTypes.includes(type)).map((resource)=>{
            var _tuples$find;
            return (_tuples$find = tuples.find($a6773e0103928585$var$matchType(resource))) != null ? _tuples$find : [
                resource,
                null
            ];
        });
        setState({
            executing: executingTuples
        }); // dispatch sequentially during which executeForDependents() can cause tuples to change
        const executedResults = executingTuples.map(([{ type: expectedType }], i)=>{
            var _getState$executing;
            const latestTuple = (_getState$executing = getState().executing) == null ? void 0 : _getState$executing[i];
            const [{ type: latestType }, maybeAction] = latestTuple != null ? latestTuple : [
                {}
            ];
            if (latestType !== expectedType) {
                setState({
                    executing: null
                });
                throw new Error('execution reached an inconsistent state');
            }
            return maybeAction ? dispatch(maybeAction) : undefined;
        });
        setState({
            executing: null
        }); // pick existing execution result or dispatch any remaining independent actions
        return tuples.map(([resource, action])=>{
            const index = executingTuples.findIndex($a6773e0103928585$var$matchType(resource));
            return index < 0 ? dispatch(action) : executedResults[index];
        });
    };
const $a6773e0103928585$export$5f7e1fd85734e71e = (routeResources, resource, action)=>({ dispatch: dispatch })=>dispatch($a6773e0103928585$export$12600f2e0e7fb2cc(routeResources, [
            [
                resource,
                action
            ]
        ]))[0];
const $a6773e0103928585$export$f71a65c89c987a02 = (routeResources, resources, actionCreator)=>$a6773e0103928585$export$12600f2e0e7fb2cc(routeResources, resources.map((resource)=>[
            resource,
            actionCreator(resource)
        ]));
const $a6773e0103928585$export$7d1ffac63c68405d = (resource, actionCreator)=>({ getState: getState, setState: setState })=>{
        var _tuples$findIndex;
        const { executing: tuples } = getState(); // find the given resource in the currently executing tuples
        const indexForResource = (_tuples$findIndex = tuples == null ? void 0 : tuples.findIndex($a6773e0103928585$var$matchType(resource))) != null ? _tuples$findIndex : -1;
        if (indexForResource < 0) return;
         // find dependent resources following given resource and revise their action
        const executing = tuples.map((tuple, i)=>{
            var _tupleResource$depend;
            const [tupleResource] = tuple;
            return i > indexForResource && ((_tupleResource$depend = tupleResource.depends) == null ? void 0 : _tupleResource$depend.includes(resource.type)) ? [
                tupleResource,
                actionCreator(tupleResource)
            ] : tuple;
        });
        setState({
            executing: executing
        });
    };
const $a6773e0103928585$export$75915f81f2a6540a = (resource, routerStoreContext)=>({ getState: getState })=>{
        var _tuples$findIndex2;
        const { type: type, depends: depends } = resource; // optimise the case of no dependencies
        if (!(depends == null ? void 0 : depends.length)) return {};
        const { executing: tuples, data: data, context: resourceStoreContext } = getState(); // dependent resource cannot be called outside execution state
        // find the given resource type in the currently executing tuples
        const indexForResource = (_tuples$findIndex2 = tuples == null ? void 0 : tuples.findIndex($a6773e0103928585$var$matchType(resource))) != null ? _tuples$findIndex2 : -1;
        if (indexForResource < 0) throw new $a6773e0103928585$export$492ad57edfe1e919(`Missing resource: "${type}" has dependencies so must not be missing`);
         // find tuples index for all the dependency elements
        const dependencyIndexTuples = depends.map((dependency)=>[
                dependency,
                tuples.findIndex($a6773e0103928585$var$matchType({
                    type: dependency
                }))
            ]); // we rely on executing tuples including all dependencies of the caller resource
        dependencyIndexTuples.forEach(([dependency, index])=>{
            if (index < 0) throw new $a6773e0103928585$export$492ad57edfe1e919(`Missing resource: "${type}" depends "${dependency}" which is missing`);
            if (index > indexForResource) throw new $a6773e0103928585$export$492ad57edfe1e919(`Illegal dependency: "${type}" depends "${dependency}" so "${dependency}" must precede "${type}"`);
        });
        return $a6773e0103928585$var$fromEntries(dependencyIndexTuples.map(([dependency, index])=>{
            const [{ getKey: getKey }] = tuples[index];
            return [
                dependency,
                (0, $fWYgZ.getSliceForResource)({
                    data: data
                }, {
                    type: dependency,
                    key: getKey(routerStoreContext, resourceStoreContext)
                })
            ];
        }));
    };
module.exports["actionWithDependencies"] = $a6773e0103928585$export$5f7e1fd85734e71e;
module.exports["mapActionWithDependencies"] = $a6773e0103928585$export$f71a65c89c987a02;
module.exports["executeForDependents"] = $a6773e0103928585$export$7d1ffac63c68405d;
module.exports["getDependencies"] = $a6773e0103928585$export$75915f81f2a6540a;

});

parcelRegister("aureP", function(module, exports) {
const $7a31d5aa8052a91b$export$4dbaaf6c79705e6c = (candidate)=>candidate instanceof Promise ? candidate : Promise.resolve(candidate);
module.exports["toPromise"] = $7a31d5aa8052a91b$export$4dbaaf6c79705e6c;

});

parcelRegister("lbfkG", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");


var $bDniu = parcelRequire("bDniu");


var $goduw = parcelRequire("goduw");

var $FOT9i = parcelRequire("FOT9i");

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

var $j1v0l = parcelRequire("j1v0l");

var $4HDYO = parcelRequire("4HDYO");


var $fgJFQ = parcelRequire("fgJFQ");


var $lxnII = parcelRequire("lxnII");

parcelRequire("eFXPq");
var $8hLIT = parcelRequire("8hLIT");
var $jO7cU = parcelRequire("jO7cU");
var $6di1Y = parcelRequire("6di1Y");
var $bx92O = parcelRequire("bx92O");
var $jxSMo = parcelRequire("jxSMo");


var $45iAl = parcelRequire("45iAl");

parcelRequire("7qPh9");
var $8vD5e = parcelRequire("8vD5e");

parcelRequire("5Ikq3");
var $i6U7G = parcelRequire("i6U7G");

const $03faaf8f97ef285c$export$36d128238e6b60f5 = {
    history: (0, $lxnII.DEFAULT_HISTORY),
    location: (0, $lxnII.DEFAULT_HISTORY).location,
    query: {},
    routes: [],
    route: (0, $lxnII.DEFAULT_ROUTE),
    match: (0, $lxnII.DEFAULT_MATCH),
    action: (0, $lxnII.DEFAULT_ACTION),
    unlisten: null,
    basePath: '',
    isStatic: false,
    onPrefetch: undefined
};
const $03faaf8f97ef285c$var$actions = {
    /**
   * Bootstraps the store with initial data.
   *
   */ bootstrapStore: (props)=>({ setState: setState, dispatch: dispatch })=>{
            const { resourceContext: resourceContext, resourceData: resourceData, basePath: basePath = '', routes: routes, initialRoute: initialRoute } = props, initialProps = (0, $bDniu.default)(props, [
                "resourceContext",
                "resourceData",
                "basePath",
                "routes",
                "initialRoute"
            ]);
            const { history: history, isStatic: isStatic } = initialProps;
            const routerContext = (0, $8hLIT.findRouterContext)(initialRoute ? [
                initialRoute
            ] : routes, {
                location: history.location,
                basePath: basePath
            });
            setState((0, $7Q5yr.default)((0, $7Q5yr.default)((0, $7Q5yr.default)({}, initialProps), routerContext), {}, {
                basePath: basePath,
                routes: routes,
                location: history.location,
                action: history.action
            }));
            (0, $45iAl.getResourceStore)().actions.hydrate({
                resourceContext: resourceContext,
                resourceData: resourceData
            });
            if (!isStatic) dispatch($03faaf8f97ef285c$var$actions.listen());
        },
    /**
   * Duplicate method that uses isServerEnvironment instead of removed isStatic prop
   * internally. We can remove this when UniversalRouter replaces Router completely.
   */ bootstrapStoreUniversal: (props)=>({ setState: setState, dispatch: dispatch })=>{
            const { resourceContext: resourceContext, resourceData: resourceData, basePath: basePath = '' } = props, initialProps = (0, $bDniu.default)(props, [
                "resourceContext",
                "resourceData",
                "basePath"
            ]);
            const { history: history, routes: routes } = initialProps;
            const routerContext = (0, $8hLIT.findRouterContext)(routes, {
                location: history.location,
                basePath: basePath
            });
            setState((0, $7Q5yr.default)((0, $7Q5yr.default)((0, $7Q5yr.default)({}, initialProps), routerContext), {}, {
                basePath: basePath,
                location: history.location,
                action: history.action
            }));
            (0, $45iAl.getResourceStore)().actions.hydrate({
                resourceContext: resourceContext,
                resourceData: resourceData
            });
            if (!(0, $bx92O.isServerEnvironment)()) dispatch($03faaf8f97ef285c$var$actions.listen());
        },
    /**
   * Uses the resource store to request resources for the route.
   * Must be dispatched after setting state with the new route context.
   *
   */ requestRouteResources: (options = {})=>({ getState: getState })=>{
            const { route: route, match: match, query: query } = getState();
            return (0, $45iAl.getResourceStore)().actions.requestAllResources({
                route: route,
                match: match,
                query: query
            }, options);
        },
    prefetchNextRouteResources: (path, nextContext)=>({ getState: getState })=>{
            const { routes: routes, basePath: basePath, onPrefetch: onPrefetch, route: route, match: match, query: query } = getState();
            const { cleanExpiredResources: cleanExpiredResources, requestResources: requestResources, getContext: getResourceStoreContext } = (0, $45iAl.getResourceStore)().actions;
            if (!nextContext && !(0, $i6U7G.isExternalAbsolutePath)(path)) {
                const location = (0, $fgJFQ.parsePath)((0, $i6U7G.getRelativePath)(path, basePath));
                nextContext = (0, $8hLIT.findRouterContext)(routes, {
                    location: location,
                    basePath: basePath
                });
            }
            if (nextContext == null) return;
            const nextLocationContext = nextContext;
            const nextResources = (0, $8vD5e.getResourcesForNextLocation)({
                route: route,
                match: match,
                query: query
            }, nextLocationContext, getResourceStoreContext());
            (0, $goduw.batch)(()=>{
                cleanExpiredResources(nextResources, nextLocationContext);
                requestResources(nextResources, nextLocationContext, {
                    prefetch: true
                });
                if (onPrefetch) onPrefetch(nextLocationContext);
            });
        },
    /**
   * Starts listening to browser history and sets the unlisten function in state.
   * Will request route resources on route change.
   *
   */ listen: ()=>({ getState: getState, setState: setState })=>{
            const { history: history } = getState();
            const stopListening = history.listen((...update)=>{
                const location = update.length === 2 ? update[0] : update[0].location;
                const action = update.length === 2 ? update[1] : update[0].action;
                const { routes: routes, basePath: basePath, match: currentMatch, route: currentRoute, query: currentQuery } = getState();
                const { cleanExpiredResources: cleanExpiredResources, requestResources: requestResources, getContext: getResourceStoreContext } = (0, $45iAl.getResourceStore)().actions;
                const nextContext = (0, $8hLIT.findRouterContext)(routes, {
                    location: location,
                    basePath: basePath
                });
                const nextLocationContext = {
                    route: nextContext.route,
                    match: nextContext.match,
                    query: nextContext.query
                };
                const nextResources = (0, $8vD5e.getResourcesForNextLocation)({
                    route: currentRoute,
                    match: currentMatch,
                    query: currentQuery
                }, nextLocationContext, getResourceStoreContext());
                /* Explicitly batch update
       * as we need resources cleaned + route changed + resource fetch started together
       * If we do not batch, React might be re-render when route changes but resource
       * fetching has not started yet, making the app render with data null */ (0, $goduw.batch)(()=>{
                    cleanExpiredResources(nextResources, nextLocationContext);
                    setState((0, $7Q5yr.default)((0, $7Q5yr.default)({}, nextContext), {}, {
                        location: location,
                        action: action
                    }));
                    requestResources(nextResources, nextLocationContext, {});
                });
            });
            setState({
                unlisten: stopListening
            });
        },
    push: (path)=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            if ((0, $i6U7G.isExternalAbsolutePath)(path)) window.location.assign(path);
            else history.push((0, $i6U7G.getRelativePath)(path, basePath));
        },
    pushTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $jO7cU.generateLocationFromPath)(route.path, (0, $7Q5yr.default)((0, $7Q5yr.default)({}, attributes), {}, {
                basePath: basePath
            }));
            (0, $jxSMo.warmupMatchRouteCache)(route, location.pathname, attributes.query, basePath);
            history.push(location);
        },
    replace: (path)=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            if ((0, $i6U7G.isExternalAbsolutePath)(path)) window.location.replace(path);
            else history.replace((0, $i6U7G.getRelativePath)(path, basePath));
        },
    replaceTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $jO7cU.generateLocationFromPath)(route.path, (0, $7Q5yr.default)((0, $7Q5yr.default)({}, attributes), {}, {
                basePath: basePath
            }));
            (0, $jxSMo.warmupMatchRouteCache)(route, location.pathname, attributes.query, basePath);
            history.replace(location);
        },
    goBack: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            history.goBack();
        },
    goForward: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            history.goForward();
        },
    registerBlock: (blocker)=>({ getState: getState })=>{
            const { history: history } = getState();
            return history.block(blocker);
        },
    getContext: ()=>({ getState: getState })=>{
            const { query: query, route: route, match: match } = getState();
            return {
                query: query,
                route: route,
                match: match
            };
        },
    getBasePath: ()=>({ getState: getState })=>{
            const { basePath: basePath } = getState();
            return basePath;
        },
    updateQueryParam: (params, updateType = 'push')=>({ getState: getState })=>{
            const { query: existingQueryParams, history: history, location: location } = getState();
            const updatedQueryParams = (0, $7Q5yr.default)((0, $7Q5yr.default)({}, existingQueryParams), params); // remove undefined keys
            Object.keys(updatedQueryParams).forEach((key)=>updatedQueryParams[key] === undefined && delete updatedQueryParams[key]);
            const existingPath = (0, $i6U7G.updateQueryParams)(location, existingQueryParams);
            const updatedPath = (0, $i6U7G.updateQueryParams)(location, updatedQueryParams);
            if (updatedPath !== existingPath) history[updateType](updatedPath);
        },
    updatePathParam: (params, updateType = 'push')=>({ getState: getState })=>{
            const { history: history, location: location, route: { path: path }, match: { params: existingPathParams }, basePath: basePath } = getState();
            const pathWithBasePath = basePath + path;
            const updatedPathParams = (0, $7Q5yr.default)((0, $7Q5yr.default)({}, existingPathParams), params);
            const updatedPath = (0, $6di1Y.default)(pathWithBasePath, updatedPathParams);
            const updatedLocation = (0, $7Q5yr.default)((0, $7Q5yr.default)({}, location), {}, {
                pathname: updatedPath
            });
            const existingRelativePath = (0, $i6U7G.getRelativeURLFromLocation)(location);
            const updatedRelativePath = (0, $i6U7G.getRelativeURLFromLocation)(updatedLocation);
            if (updatedRelativePath !== existingRelativePath) history[updateType](updatedRelativePath);
        }
};
const $03faaf8f97ef285c$export$1cf0ecab63b1963c = (0, $1P1Tu.createStore)({
    initialState: $03faaf8f97ef285c$export$36d128238e6b60f5,
    actions: $03faaf8f97ef285c$var$actions,
    name: 'router'
});
const $03faaf8f97ef285c$export$d6b817abe7a77ea5 = (0, $FOT9i.createContainer)($03faaf8f97ef285c$export$1cf0ecab63b1963c, {
    displayName: 'RouterContainer',
    onInit: ()=>({ dispatch: dispatch }, props)=>{
            dispatch($03faaf8f97ef285c$var$actions.bootstrapStore(props));
            !props.isStatic && dispatch($03faaf8f97ef285c$var$actions.requestRouteResources());
        },
    onCleanup: ()=>()=>{}
});
const $03faaf8f97ef285c$export$b33f9392316de69d = (0, $FOT9i.createContainer)($03faaf8f97ef285c$export$1cf0ecab63b1963c, {
    displayName: 'UniversalRouterContainer',
    onInit: ()=>({ dispatch: dispatch }, props)=>{
            dispatch($03faaf8f97ef285c$var$actions.bootstrapStoreUniversal(props));
            !(0, $bx92O.isServerEnvironment)() && dispatch($03faaf8f97ef285c$var$actions.requestRouteResources());
        },
    onCleanup: ()=>()=>{}
});
const $03faaf8f97ef285c$export$672d721d310ff5f0 = (0, $j1v0l.createSubscriber)($03faaf8f97ef285c$export$1cf0ecab63b1963c, {
    displayName: 'BaseRouterSubscriber'
});
const $03faaf8f97ef285c$export$afda200b5577e7bf = (0, $j1v0l.createSubscriber)($03faaf8f97ef285c$export$1cf0ecab63b1963c, {
    displayName: 'RouterActionsSubscriber',
    selector: null
});
const $03faaf8f97ef285c$export$2e249c5b0c1716a7 = (0, $j1v0l.createSubscriber)($03faaf8f97ef285c$export$1cf0ecab63b1963c, {
    selector: (state)=>Boolean(state.route && state.route.resources)
});
const $03faaf8f97ef285c$export$9569010eab09ae9e = (0, $9zUhf.createHook)($03faaf8f97ef285c$export$1cf0ecab63b1963c);
const $03faaf8f97ef285c$export$dce62b3e98a54741 = (0, $9zUhf.createHook)($03faaf8f97ef285c$export$1cf0ecab63b1963c, {
    selector: null
});
function $03faaf8f97ef285c$export$95ab46bba7ea7a22(selector) {
    const useHook = (0, $9zUhf.createHook)($03faaf8f97ef285c$export$1cf0ecab63b1963c, {
        selector: selector
    });
    return function useRouterSelector(...args) {
        return useHook(...args)[0];
    };
}
const $03faaf8f97ef285c$export$5ccad187366c8494 = ()=>(0, $4HDYO.defaultRegistry).getStore($03faaf8f97ef285c$export$1cf0ecab63b1963c); // @ts-ignore accessing private store property
const $03faaf8f97ef285c$export$ebf37f7e180b13a9 = ()=>$03faaf8f97ef285c$export$5ccad187366c8494().storeState.getState();
module.exports["RouterStore"] = $03faaf8f97ef285c$export$1cf0ecab63b1963c;
module.exports["RouterContainer"] = $03faaf8f97ef285c$export$d6b817abe7a77ea5;
module.exports["RouterSubscriber"] = $03faaf8f97ef285c$export$672d721d310ff5f0;
module.exports["RouterActionsSubscriber"] = $03faaf8f97ef285c$export$afda200b5577e7bf;
module.exports["useRouterStore"] = $03faaf8f97ef285c$export$9569010eab09ae9e;
module.exports["useRouterStoreStatic"] = $03faaf8f97ef285c$export$dce62b3e98a54741;
module.exports["createRouterSelector"] = $03faaf8f97ef285c$export$95ab46bba7ea7a22;
module.exports["getRouterStore"] = $03faaf8f97ef285c$export$5ccad187366c8494;
module.exports["getRouterState"] = $03faaf8f97ef285c$export$ebf37f7e180b13a9;

});

parcelRegister("lxnII", function(module, exports) {

var $9577u = parcelRequire("9577u");


var $cltiJ = parcelRequire("cltiJ");

const $fadf146424055c17$export$7c22f8f9552f689e = {
    pathname: '',
    search: '',
    hash: ''
};
const $fadf146424055c17$export$2de13e891a662beb = {
    params: {},
    isExact: false,
    path: '',
    url: '',
    query: {}
};
const $fadf146424055c17$export$4eadc79233226325 = {
    path: '',
    component: ()=>null,
    name: ''
};
const $fadf146424055c17$export$39607c9878cf5148 = (0, $cltiJ.createLegacyHistory)();
const $fadf146424055c17$export$1515254c8c90bebb = {
    location: $fadf146424055c17$export$7c22f8f9552f689e,
    push: (0, (/*@__PURE__*/$parcel$interopDefault($9577u))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($9577u))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($9577u))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($9577u))),
    listen: (0, (/*@__PURE__*/$parcel$interopDefault($9577u))),
    block: (0, (/*@__PURE__*/$parcel$interopDefault($9577u))),
    createHref: (0, (/*@__PURE__*/$parcel$interopDefault($9577u)))
};
const $fadf146424055c17$export$fa440ddf675c8a93 = 'POP';
module.exports["DEFAULT_MATCH"] = $fadf146424055c17$export$2de13e891a662beb;
module.exports["DEFAULT_ROUTE"] = $fadf146424055c17$export$4eadc79233226325;
module.exports["DEFAULT_HISTORY"] = $fadf146424055c17$export$39607c9878cf5148;
module.exports["DEFAULT_ACTION"] = $fadf146424055c17$export$fa440ddf675c8a93;

});

parcelRegister("9577u", function(module, exports) {
/**
 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize include="noop" exports="npm" -o ./foo`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /**
 * A no-operation function that returns `undefined` regardless of the
 * arguments it receives.
 *
 * @static
 * @memberOf _
 * @category Util
 * @example
 *
 * var object = { 'user': 'fred' };
 *
 * _.noop(object) === undefined;
 * // => true
 */ function $69ca1a8237733efd$var$noop() {
// No operation performed.
}
module.exports = $69ca1a8237733efd$var$noop;

});

parcelRegister("cltiJ", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");


var $fgJFQ = parcelRequire("fgJFQ");


var $ldFTj = parcelRequire("ldFTj");


var $9577u = parcelRequire("9577u");

const $8fce2cd0ed4f1226$var$hasWindow = ()=>typeof window !== 'undefined';
const $8fce2cd0ed4f1226$var$methodsPlaceholders = {
    push: (0, (/*@__PURE__*/$parcel$interopDefault($9577u))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($9577u))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($9577u))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($9577u))),
    listen: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($9577u))),
    block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($9577u)))
};
const $8fce2cd0ed4f1226$var$getLocation = ()=>{
    // todo - don't force non-optional search and hash
    const { pathname: pathname = '', search: search = '', hash: hash = '' } = $8fce2cd0ed4f1226$var$hasWindow() && window.location || {};
    return {
        pathname: pathname,
        search: search,
        hash: hash
    };
};
const $8fce2cd0ed4f1226$var$createLegacyListener = (updateExposedLocation)=>{
    const node = document.querySelector('#content');
    let prevHref = window.location.href;
    let listeners = [];
    const historyStack = [
        prevHref
    ]; // note: window.history.length is capped at 50 entries
    let prevHistoryLength = window.history.length;
    let historyIndex = 0;
    const getAction = ()=>{
        const currentHref = window.location.href;
        if (prevHistoryLength === window.history.length) {
            if (historyStack[historyIndex - 1] === currentHref) {
                historyIndex -= 1;
                return 'POP';
            }
            if (historyStack[historyIndex + 1] === currentHref) {
                historyIndex += 1;
                return 'POP';
            }
            historyStack[historyStack.length - 1] = currentHref;
            return 'REPLACE';
        }
        historyStack.push(currentHref);
        historyIndex += 1;
        prevHistoryLength = window.history.length;
        return 'PUSH';
    };
    const onNodeChanges = (0, (/*@__PURE__*/$parcel$interopDefault($ldFTj)))(()=>{
        if (prevHref !== window.location.href) {
            const newLocation = $8fce2cd0ed4f1226$var$getLocation();
            const action = getAction();
            updateExposedLocation(newLocation, action);
            listeners.forEach((listener)=>listener(newLocation, action));
            prevHref = window.location.href;
        }
    }, 50);
    if (node) {
        const observer = new window.MutationObserver(onNodeChanges);
        observer.observe(node, {
            childList: true,
            subtree: true,
            attributes: true,
            characterData: true
        });
    }
    return (listener)=>{
        listeners = listeners.concat(listener);
        return ()=>{
            listeners = listeners.filter((lst)=>lst !== listener);
        };
    };
};
const $8fce2cd0ed4f1226$export$883c3f3b6c000133 = ()=>{
    let currentLocation = $8fce2cd0ed4f1226$var$getLocation();
    let currentAction = 'PUSH';
    const updateExposedLocation = (v, a)=>{
        currentLocation = v;
        currentAction = a;
    };
    return (0, $7Q5yr.default)({
        get location () {
            return currentLocation;
        },
        get length () {
            return $8fce2cd0ed4f1226$var$hasWindow() ? window.history.length : 1; // default length is 1
        },
        get action () {
            return currentAction;
        }
    }, $8fce2cd0ed4f1226$var$hasWindow() ? {
        push: (path)=>window.location.assign(path),
        replace: (path)=>window.history.replaceState({}, document.title, path),
        goBack: ()=>window.history.back(),
        goForward: ()=>window.history.forward(),
        listen: $8fce2cd0ed4f1226$var$createLegacyListener(updateExposedLocation),
        block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($9577u))),
        createHref: (location)=>(0, $fgJFQ.createPath)(location)
    } : $8fce2cd0ed4f1226$var$methodsPlaceholders);
};
module.exports["createLegacyHistory"] = $8fce2cd0ed4f1226$export$883c3f3b6c000133;

});

parcelRegister("ldFTj", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $f72b4e993b710344$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $f72b4e993b710344$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $f72b4e993b710344$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $f72b4e993b710344$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $f72b4e993b710344$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $f72b4e993b710344$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $f72b4e993b710344$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $f72b4e993b710344$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $f72b4e993b710344$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $f72b4e993b710344$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $f72b4e993b710344$var$root = $f72b4e993b710344$var$freeGlobal || $f72b4e993b710344$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $f72b4e993b710344$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $f72b4e993b710344$var$objectToString = $f72b4e993b710344$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $f72b4e993b710344$var$nativeMax = Math.max, $f72b4e993b710344$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $f72b4e993b710344$var$now = function() {
    return $f72b4e993b710344$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $f72b4e993b710344$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($f72b4e993b710344$var$FUNC_ERROR_TEXT);
    wait = $f72b4e993b710344$var$toNumber(wait) || 0;
    if ($f72b4e993b710344$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $f72b4e993b710344$var$nativeMax($f72b4e993b710344$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $f72b4e993b710344$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $f72b4e993b710344$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($f72b4e993b710344$var$now());
    }
    function debounced() {
        var time = $f72b4e993b710344$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $f72b4e993b710344$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $f72b4e993b710344$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $f72b4e993b710344$var$isSymbol(value) {
    return typeof value == 'symbol' || $f72b4e993b710344$var$isObjectLike(value) && $f72b4e993b710344$var$objectToString.call(value) == $f72b4e993b710344$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $f72b4e993b710344$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($f72b4e993b710344$var$isSymbol(value)) return $f72b4e993b710344$var$NAN;
    if ($f72b4e993b710344$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $f72b4e993b710344$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($f72b4e993b710344$var$reTrim, '');
    var isBinary = $f72b4e993b710344$var$reIsBinary.test(value);
    return isBinary || $f72b4e993b710344$var$reIsOctal.test(value) ? $f72b4e993b710344$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $f72b4e993b710344$var$reIsBadHex.test(value) ? $f72b4e993b710344$var$NAN : +value;
}
module.exports = $f72b4e993b710344$var$debounce;

});

parcelRegister("eFXPq", function(module, exports) {
$parcel$export(module.exports, "warmupMatchRouteCache", () => (parcelRequire("jxSMo")).warmupMatchRouteCache);
$parcel$export(module.exports, "generatePath", () => (parcelRequire("6di1Y")).default);
$parcel$export(module.exports, "generateLocationFromPath", () => (parcelRequire("jO7cU")).generateLocationFromPath);
$parcel$export(module.exports, "isServerEnvironment", () => (parcelRequire("bx92O")).isServerEnvironment);
$parcel$export(module.exports, "findRouterContext", () => (parcelRequire("8hLIT")).findRouterContext);
$parcel$export(module.exports, "createRouterContext", () => (parcelRequire("8hLIT")).createRouterContext);

var $jxSMo = parcelRequire("jxSMo");


var $6di1Y = parcelRequire("6di1Y");


var $jO7cU = parcelRequire("jO7cU");


var $cltiJ = parcelRequire("cltiJ");


var $bx92O = parcelRequire("bx92O");


var $8hLIT = parcelRequire("8hLIT");


});

parcelRegister("jxSMo", function(module, exports) {
$parcel$export(module.exports, "default", () => $e3ab9777fad27a78$export$2e2bcd8739ae039);

var $jBvme = parcelRequire("jBvme");


var $e3fps = parcelRequire("e3fps");


var $jwQ9Q = parcelRequire("jwQ9Q");

/**
 * Does the given `pathname` and `queryStr` match a route in `routes`.
 *
 * Heavily based on https://github.com/ReactTraining/react-router/blob/master/packages/react-router-config/modules/matchRoute.js
 *
 * Note: This does not support nested routes at this stage.
 */ const $e3ab9777fad27a78$var$matchRoute = (routes, pathname, queryParams = {}, basePath = '')=>{
    const queryParamObject = typeof queryParams === 'string' ? (0, $jBvme.qs).parse(queryParams) : queryParams;
    const cachedMatch = (0, $jwQ9Q.matchRouteCache).get(pathname, queryParamObject, basePath);
    if (cachedMatch && routes.includes(cachedMatch.route)) return cachedMatch;
    for(let i = 0; i < routes.length; i++){
        const matchedRoute = (0, $e3fps.default)(routes[i], pathname, queryParamObject, basePath);
        if (matchedRoute) {
            (0, $jwQ9Q.matchRouteCache).set(pathname, queryParamObject, basePath, matchedRoute);
            return matchedRoute;
        }
    }
    return null;
};
const $e3ab9777fad27a78$export$ce5b73cebfeaa567 = (routes, pathname, queryParams, basePath = '')=>$e3ab9777fad27a78$var$matchRoute(routes, pathname, queryParams, basePath);
const $e3ab9777fad27a78$export$4e76f1d455ef7c95 = (route, pathname, queryParams, basePath = '')=>{
    $e3ab9777fad27a78$var$matchRoute([
        route
    ], pathname, queryParams, basePath);
};
var $e3ab9777fad27a78$export$2e2bcd8739ae039 = (routes, pathname, queryParams, basePath = '')=>$e3ab9777fad27a78$var$matchRoute(routes, pathname, queryParams, basePath);
module.exports["warmupMatchRouteCache"] = $e3ab9777fad27a78$export$4e76f1d455ef7c95;

});

parcelRegister("jBvme", function(module, exports) {
'use strict';

var $1GmRG = parcelRequire("1GmRG");


var $abZty = parcelRequire("abZty");

var $e459cbfd8a82954e$var$controlOrWhitespace = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/, $e459cbfd8a82954e$var$CRHTLF = /[\n\r\t]/g, $e459cbfd8a82954e$var$slashes = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//, $e459cbfd8a82954e$var$port = /:\d+$/, $e459cbfd8a82954e$var$protocolre = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\\/]+)?([\S\s]*)/i, $e459cbfd8a82954e$var$windowsDriveLetter = /^[a-zA-Z]:/;
/**
 * Remove control characters and whitespace from the beginning of a string.
 *
 * @param {Object|String} str String to trim.
 * @returns {String} A new string representing `str` stripped of control
 *     characters and whitespace from its beginning.
 * @public
 */ function $e459cbfd8a82954e$var$trimLeft(str) {
    return (str ? str : '').toString().replace($e459cbfd8a82954e$var$controlOrWhitespace, '');
}
/**
 * These are the parse rules for the URL parser, it informs the parser
 * about:
 *
 * 0. The char it Needs to parse, if it's a string it should be done using
 *    indexOf, RegExp using exec and NaN means set as current value.
 * 1. The property we should set when parsing this value.
 * 2. Indication if it's backwards or forward parsing, when set as number it's
 *    the value of extra chars that should be split off.
 * 3. Inherit from location if non existing in the parser.
 * 4. `toLowerCase` the resulting value.
 */ var $e459cbfd8a82954e$var$rules = [
    [
        '#',
        'hash'
    ],
    [
        '?',
        'query'
    ],
    function sanitize(address, url) {
        return $e459cbfd8a82954e$var$isSpecial(url.protocol) ? address.replace(/\\/g, '/') : address;
    },
    [
        '/',
        'pathname'
    ],
    [
        '@',
        'auth',
        1
    ],
    [
        NaN,
        'host',
        undefined,
        1,
        1
    ],
    [
        /:(\d*)$/,
        'port',
        undefined,
        1
    ],
    [
        NaN,
        'hostname',
        undefined,
        1,
        1
    ] // Set left over.
];
/**
 * These properties should not be copied or inherited from. This is only needed
 * for all non blob URL's as a blob URL does not include a hash, only the
 * origin.
 *
 * @type {Object}
 * @private
 */ var $e459cbfd8a82954e$var$ignore = {
    hash: 1,
    query: 1
};
/**
 * The location object differs when your code is loaded through a normal page,
 * Worker or through a worker using a blob. And with the blobble begins the
 * trouble as the location object will contain the URL of the blob, not the
 * location of the page where our code is loaded in. The actual origin is
 * encoded in the `pathname` so we can thankfully generate a good "default"
 * location from it so we can generate proper relative URL's again.
 *
 * @param {Object|String} loc Optional default location object.
 * @returns {Object} lolcation object.
 * @public
 */ function $e459cbfd8a82954e$var$lolcation(loc) {
    var globalVar;
    if (typeof window !== 'undefined') globalVar = window;
    else if (typeof $parcel$global !== 'undefined') globalVar = $parcel$global;
    else if (typeof self !== 'undefined') globalVar = self;
    else globalVar = {};
    var location = globalVar.location || {};
    loc = loc || location;
    var finaldestination = {}, type = typeof loc, key;
    if ('blob:' === loc.protocol) finaldestination = new $e459cbfd8a82954e$var$Url(unescape(loc.pathname), {});
    else if ('string' === type) {
        finaldestination = new $e459cbfd8a82954e$var$Url(loc, {});
        for(key in $e459cbfd8a82954e$var$ignore)delete finaldestination[key];
    } else if ('object' === type) {
        for(key in loc){
            if (key in $e459cbfd8a82954e$var$ignore) continue;
            finaldestination[key] = loc[key];
        }
        if (finaldestination.slashes === undefined) finaldestination.slashes = $e459cbfd8a82954e$var$slashes.test(loc.href);
    }
    return finaldestination;
}
/**
 * Check whether a protocol scheme is special.
 *
 * @param {String} The protocol scheme of the URL
 * @return {Boolean} `true` if the protocol scheme is special, else `false`
 * @private
 */ function $e459cbfd8a82954e$var$isSpecial(scheme) {
    return scheme === 'file:' || scheme === 'ftp:' || scheme === 'http:' || scheme === 'https:' || scheme === 'ws:' || scheme === 'wss:';
}
/**
 * @typedef ProtocolExtract
 * @type Object
 * @property {String} protocol Protocol matched in the URL, in lowercase.
 * @property {Boolean} slashes `true` if protocol is followed by "//", else `false`.
 * @property {String} rest Rest of the URL that is not part of the protocol.
 */ /**
 * Extract protocol information from a URL with/without double slash ("//").
 *
 * @param {String} address URL we want to extract from.
 * @param {Object} location
 * @return {ProtocolExtract} Extracted information.
 * @private
 */ function $e459cbfd8a82954e$var$extractProtocol(address, location) {
    address = $e459cbfd8a82954e$var$trimLeft(address);
    address = address.replace($e459cbfd8a82954e$var$CRHTLF, '');
    location = location || {};
    var match = $e459cbfd8a82954e$var$protocolre.exec(address);
    var protocol = match[1] ? match[1].toLowerCase() : '';
    var forwardSlashes = !!match[2];
    var otherSlashes = !!match[3];
    var slashesCount = 0;
    var rest;
    if (forwardSlashes) {
        if (otherSlashes) {
            rest = match[2] + match[3] + match[4];
            slashesCount = match[2].length + match[3].length;
        } else {
            rest = match[2] + match[4];
            slashesCount = match[2].length;
        }
    } else if (otherSlashes) {
        rest = match[3] + match[4];
        slashesCount = match[3].length;
    } else rest = match[4];
    if (protocol === 'file:') {
        if (slashesCount >= 2) rest = rest.slice(2);
    } else if ($e459cbfd8a82954e$var$isSpecial(protocol)) rest = match[4];
    else if (protocol) {
        if (forwardSlashes) rest = rest.slice(2);
    } else if (slashesCount >= 2 && $e459cbfd8a82954e$var$isSpecial(location.protocol)) rest = match[4];
    return {
        protocol: protocol,
        slashes: forwardSlashes || $e459cbfd8a82954e$var$isSpecial(protocol),
        slashesCount: slashesCount,
        rest: rest
    };
}
/**
 * Resolve a relative URL pathname against a base URL pathname.
 *
 * @param {String} relative Pathname of the relative URL.
 * @param {String} base Pathname of the base URL.
 * @return {String} Resolved pathname.
 * @private
 */ function $e459cbfd8a82954e$var$resolve(relative, base) {
    if (relative === '') return base;
    var path = (base || '/').split('/').slice(0, -1).concat(relative.split('/')), i = path.length, last = path[i - 1], unshift = false, up = 0;
    while(i--){
        if (path[i] === '.') path.splice(i, 1);
        else if (path[i] === '..') {
            path.splice(i, 1);
            up++;
        } else if (up) {
            if (i === 0) unshift = true;
            path.splice(i, 1);
            up--;
        }
    }
    if (unshift) path.unshift('');
    if (last === '.' || last === '..') path.push('');
    return path.join('/');
}
/**
 * The actual URL instance. Instead of returning an object we've opted-in to
 * create an actual constructor as it's much more memory efficient and
 * faster and it pleases my OCD.
 *
 * It is worth noting that we should not use `URL` as class name to prevent
 * clashes with the global URL instance that got introduced in browsers.
 *
 * @constructor
 * @param {String} address URL we want to parse.
 * @param {Object|String} [location] Location defaults for relative paths.
 * @param {Boolean|Function} [parser] Parser for the query string.
 * @private
 */ function $e459cbfd8a82954e$var$Url(address, location, parser) {
    address = $e459cbfd8a82954e$var$trimLeft(address);
    address = address.replace($e459cbfd8a82954e$var$CRHTLF, '');
    if (!(this instanceof $e459cbfd8a82954e$var$Url)) return new $e459cbfd8a82954e$var$Url(address, location, parser);
    var relative, extracted, parse, instruction, index, key, instructions = $e459cbfd8a82954e$var$rules.slice(), type = typeof location, url = this, i = 0;
    //
    // The following if statements allows this module two have compatibility with
    // 2 different API:
    //
    // 1. Node.js's `url.parse` api which accepts a URL, boolean as arguments
    //    where the boolean indicates that the query string should also be parsed.
    //
    // 2. The `URL` interface of the browser which accepts a URL, object as
    //    arguments. The supplied object will be used as default values / fall-back
    //    for relative paths.
    //
    if ('object' !== type && 'string' !== type) {
        parser = location;
        location = null;
    }
    if (parser && 'function' !== typeof parser) parser = $abZty.parse;
    location = $e459cbfd8a82954e$var$lolcation(location);
    //
    // Extract protocol information before running the instructions.
    //
    extracted = $e459cbfd8a82954e$var$extractProtocol(address || '', location);
    relative = !extracted.protocol && !extracted.slashes;
    url.slashes = extracted.slashes || relative && location.slashes;
    url.protocol = extracted.protocol || location.protocol || '';
    address = extracted.rest;
    //
    // When the authority component is absent the URL starts with a path
    // component.
    //
    if (extracted.protocol === 'file:' && (extracted.slashesCount !== 2 || $e459cbfd8a82954e$var$windowsDriveLetter.test(address)) || !extracted.slashes && (extracted.protocol || extracted.slashesCount < 2 || !$e459cbfd8a82954e$var$isSpecial(url.protocol))) instructions[3] = [
        /(.*)/,
        'pathname'
    ];
    for(; i < instructions.length; i++){
        instruction = instructions[i];
        if (typeof instruction === 'function') {
            address = instruction(address, url);
            continue;
        }
        parse = instruction[0];
        key = instruction[1];
        if (parse !== parse) url[key] = address;
        else if ('string' === typeof parse) {
            index = parse === '@' ? address.lastIndexOf(parse) : address.indexOf(parse);
            if (~index) {
                if ('number' === typeof instruction[2]) {
                    url[key] = address.slice(0, index);
                    address = address.slice(index + instruction[2]);
                } else {
                    url[key] = address.slice(index);
                    address = address.slice(0, index);
                }
            }
        } else if (index = parse.exec(address)) {
            url[key] = index[1];
            address = address.slice(0, index.index);
        }
        url[key] = url[key] || (relative && instruction[3] ? location[key] || '' : '');
        //
        // Hostname, host and protocol should be lowercased so they can be used to
        // create a proper `origin`.
        //
        if (instruction[4]) url[key] = url[key].toLowerCase();
    }
    //
    // Also parse the supplied query string in to an object. If we're supplied
    // with a custom parser as function use that instead of the default build-in
    // parser.
    //
    if (parser) url.query = parser(url.query);
    //
    // If the URL is relative, resolve the pathname against the base URL.
    //
    if (relative && location.slashes && url.pathname.charAt(0) !== '/' && (url.pathname !== '' || location.pathname !== '')) url.pathname = $e459cbfd8a82954e$var$resolve(url.pathname, location.pathname);
    //
    // Default to a / for pathname if none exists. This normalizes the URL
    // to always have a /
    //
    if (url.pathname.charAt(0) !== '/' && $e459cbfd8a82954e$var$isSpecial(url.protocol)) url.pathname = '/' + url.pathname;
    //
    // We should not add port numbers if they are already the default port number
    // for a given protocol. As the host also contains the port number we're going
    // override it with the hostname which contains no port number.
    //
    if (!$1GmRG(url.port, url.protocol)) {
        url.host = url.hostname;
        url.port = '';
    }
    //
    // Parse down the `auth` for the username and password.
    //
    url.username = url.password = '';
    if (url.auth) {
        index = url.auth.indexOf(':');
        if (~index) {
            url.username = url.auth.slice(0, index);
            url.username = encodeURIComponent(decodeURIComponent(url.username));
            url.password = url.auth.slice(index + 1);
            url.password = encodeURIComponent(decodeURIComponent(url.password));
        } else url.username = encodeURIComponent(decodeURIComponent(url.auth));
        url.auth = url.password ? url.username + ':' + url.password : url.username;
    }
    url.origin = url.protocol !== 'file:' && $e459cbfd8a82954e$var$isSpecial(url.protocol) && url.host ? url.protocol + '//' + url.host : 'null';
    //
    // The href is just the compiled result.
    //
    url.href = url.toString();
}
/**
 * This is convenience method for changing properties in the URL instance to
 * insure that they all propagate correctly.
 *
 * @param {String} part          Property we need to adjust.
 * @param {Mixed} value          The newly assigned value.
 * @param {Boolean|Function} fn  When setting the query, it will be the function
 *                               used to parse the query.
 *                               When setting the protocol, double slash will be
 *                               removed from the final url if it is true.
 * @returns {URL} URL instance for chaining.
 * @public
 */ function $e459cbfd8a82954e$var$set(part, value, fn) {
    var url = this;
    switch(part){
        case 'query':
            if ('string' === typeof value && value.length) value = (fn || $abZty.parse)(value);
            url[part] = value;
            break;
        case 'port':
            url[part] = value;
            if (!$1GmRG(value, url.protocol)) {
                url.host = url.hostname;
                url[part] = '';
            } else if (value) url.host = url.hostname + ':' + value;
            break;
        case 'hostname':
            url[part] = value;
            if (url.port) value += ':' + url.port;
            url.host = value;
            break;
        case 'host':
            url[part] = value;
            if ($e459cbfd8a82954e$var$port.test(value)) {
                value = value.split(':');
                url.port = value.pop();
                url.hostname = value.join(':');
            } else {
                url.hostname = value;
                url.port = '';
            }
            break;
        case 'protocol':
            url.protocol = value.toLowerCase();
            url.slashes = !fn;
            break;
        case 'pathname':
        case 'hash':
            if (value) {
                var char = part === 'pathname' ? '/' : '#';
                url[part] = value.charAt(0) !== char ? char + value : value;
            } else url[part] = value;
            break;
        case 'username':
        case 'password':
            url[part] = encodeURIComponent(value);
            break;
        case 'auth':
            var index = value.indexOf(':');
            if (~index) {
                url.username = value.slice(0, index);
                url.username = encodeURIComponent(decodeURIComponent(url.username));
                url.password = value.slice(index + 1);
                url.password = encodeURIComponent(decodeURIComponent(url.password));
            } else url.username = encodeURIComponent(decodeURIComponent(value));
    }
    for(var i = 0; i < $e459cbfd8a82954e$var$rules.length; i++){
        var ins = $e459cbfd8a82954e$var$rules[i];
        if (ins[4]) url[ins[1]] = url[ins[1]].toLowerCase();
    }
    url.auth = url.password ? url.username + ':' + url.password : url.username;
    url.origin = url.protocol !== 'file:' && $e459cbfd8a82954e$var$isSpecial(url.protocol) && url.host ? url.protocol + '//' + url.host : 'null';
    url.href = url.toString();
    return url;
}
/**
 * Transform the properties back in to a valid and full URL string.
 *
 * @param {Function} stringify Optional query stringify function.
 * @returns {String} Compiled version of the URL.
 * @public
 */ function $e459cbfd8a82954e$var$toString(stringify) {
    if (!stringify || 'function' !== typeof stringify) stringify = $abZty.stringify;
    var query, url = this, host = url.host, protocol = url.protocol;
    if (protocol && protocol.charAt(protocol.length - 1) !== ':') protocol += ':';
    var result = protocol + (url.protocol && url.slashes || $e459cbfd8a82954e$var$isSpecial(url.protocol) ? '//' : '');
    if (url.username) {
        result += url.username;
        if (url.password) result += ':' + url.password;
        result += '@';
    } else if (url.password) {
        result += ':' + url.password;
        result += '@';
    } else if (url.protocol !== 'file:' && $e459cbfd8a82954e$var$isSpecial(url.protocol) && !host && url.pathname !== '/') //
    // Add back the empty userinfo, otherwise the original invalid URL
    // might be transformed into a valid one with `url.pathname` as host.
    //
    result += '@';
    //
    // Trailing colon is removed from `url.host` when it is parsed. If it still
    // ends with a colon, then add back the trailing colon that was removed. This
    // prevents an invalid URL from being transformed into a valid one.
    //
    if (host[host.length - 1] === ':' || $e459cbfd8a82954e$var$port.test(url.hostname) && !url.port) host += ':';
    result += host + url.pathname;
    query = 'object' === typeof url.query ? stringify(url.query) : url.query;
    if (query) result += '?' !== query.charAt(0) ? '?' + query : query;
    if (url.hash) result += url.hash;
    return result;
}
$e459cbfd8a82954e$var$Url.prototype = {
    set: $e459cbfd8a82954e$var$set,
    toString: $e459cbfd8a82954e$var$toString
};
//
// Expose the URL parser and some additional properties that might be useful for
// others or testing.
//
$e459cbfd8a82954e$var$Url.extractProtocol = $e459cbfd8a82954e$var$extractProtocol;
$e459cbfd8a82954e$var$Url.location = $e459cbfd8a82954e$var$lolcation;
$e459cbfd8a82954e$var$Url.trimLeft = $e459cbfd8a82954e$var$trimLeft;
$e459cbfd8a82954e$var$Url.qs = $abZty;
module.exports = $e459cbfd8a82954e$var$Url;

});

parcelRegister("1GmRG", function(module, exports) {
'use strict';
/**
 * Check if we're required to add a port number.
 *
 * @see https://url.spec.whatwg.org/#default-port
 * @param {Number|String} port Port number we need to check
 * @param {String} protocol Protocol we need to check against.
 * @returns {Boolean} Is it a default port for the given protocol
 * @api private
 */ module.exports = function required(port, protocol) {
    protocol = protocol.split(':')[0];
    port = +port;
    if (!port) return false;
    switch(protocol){
        case 'http':
        case 'ws':
            return port !== 80;
        case 'https':
        case 'wss':
            return port !== 443;
        case 'ftp':
            return port !== 21;
        case 'gopher':
            return port !== 70;
        case 'file':
            return false;
    }
    return port !== 0;
};

});

parcelRegister("abZty", function(module, exports) {
$parcel$export(module.exports, "stringify", () => $76ba9e442b1f2d97$export$fac44ee5b035f737, (v) => $76ba9e442b1f2d97$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parse", () => $76ba9e442b1f2d97$export$98e6a39c04603d36, (v) => $76ba9e442b1f2d97$export$98e6a39c04603d36 = v);
//
// Expose the module.
//
var $76ba9e442b1f2d97$export$fac44ee5b035f737;
var $76ba9e442b1f2d97$export$98e6a39c04603d36;
'use strict';
var $76ba9e442b1f2d97$var$has = Object.prototype.hasOwnProperty, $76ba9e442b1f2d97$var$undef;
/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String|Null} The decoded string.
 * @api private
 */ function $76ba9e442b1f2d97$var$decode(input) {
    try {
        return decodeURIComponent(input.replace(/\+/g, ' '));
    } catch (e) {
        return null;
    }
}
/**
 * Attempts to encode a given input.
 *
 * @param {String} input The string that needs to be encoded.
 * @returns {String|Null} The encoded string.
 * @api private
 */ function $76ba9e442b1f2d97$var$encode(input) {
    try {
        return encodeURIComponent(input);
    } catch (e) {
        return null;
    }
}
/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */ function $76ba9e442b1f2d97$var$querystring(query) {
    var parser = /([^=?#&]+)=?([^&]*)/g, result = {}, part;
    while(part = parser.exec(query)){
        var key = $76ba9e442b1f2d97$var$decode(part[1]), value = $76ba9e442b1f2d97$var$decode(part[2]);
        //
        // Prevent overriding of existing properties. This ensures that build-in
        // methods like `toString` or __proto__ are not overriden by malicious
        // querystrings.
        //
        // In the case if failed decoding, we want to omit the key/value pairs
        // from the result.
        //
        if (key === null || value === null || key in result) continue;
        result[key] = value;
    }
    return result;
}
/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */ function $76ba9e442b1f2d97$var$querystringify(obj, prefix) {
    prefix = prefix || '';
    var pairs = [], value, key;
    //
    // Optionally prefix with a '?' if needed
    //
    if ('string' !== typeof prefix) prefix = '?';
    for(key in obj)if ($76ba9e442b1f2d97$var$has.call(obj, key)) {
        value = obj[key];
        //
        // Edge cases where we actually want to encode the value to an empty
        // string instead of the stringified value.
        //
        if (!value && (value === null || value === $76ba9e442b1f2d97$var$undef || isNaN(value))) value = '';
        key = $76ba9e442b1f2d97$var$encode(key);
        value = $76ba9e442b1f2d97$var$encode(value);
        //
        // If we failed to encode the strings, we should bail out as we don't
        // want to add invalid strings to the query.
        //
        if (key === null || value === null) continue;
        pairs.push(key + '=' + value);
    }
    return pairs.length ? prefix + pairs.join('&') : '';
}
$76ba9e442b1f2d97$export$fac44ee5b035f737 = $76ba9e442b1f2d97$var$querystringify;
$76ba9e442b1f2d97$export$98e6a39c04603d36 = $76ba9e442b1f2d97$var$querystring;

});

parcelRegister("e3fps", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");


var $jK2nG = parcelRequire("jK2nG");


var $90bgH = parcelRequire("90bgH");

/* This should match what react-router does to compute a root match. */ const $a3ad4c8c7989e5a3$var$computeRootMatch = (pathname)=>({
        path: '/',
        url: '/',
        params: {},
        isExact: pathname === '/',
        query: {}
    });
function $a3ad4c8c7989e5a3$var$execRouteMatching(route, pathname, queryObj, basePath) {
    const pathMatch = route.path ? (0, $jK2nG.default)(pathname, {
        path: route.path,
        exact: route.exact,
        basePath: basePath
    }) : $a3ad4c8c7989e5a3$var$computeRootMatch(pathname);
    let match = pathMatch;
    if (pathMatch && route.query) match = (0, $90bgH.default)(route.query, queryObj, pathMatch);
    else if (pathMatch) match = (0, $7Q5yr.default)((0, $7Q5yr.default)({}, pathMatch), {}, {
        query: {}
    });
    if (match) return {
        match: match,
        route: route
    };
    return null;
}
var $a3ad4c8c7989e5a3$export$2e2bcd8739ae039 = $a3ad4c8c7989e5a3$var$execRouteMatching;
module.exports["default"] = $a3ad4c8c7989e5a3$export$2e2bcd8739ae039;

});

parcelRegister("jK2nG", function(module, exports) {
// TAKEN FROM https://github.com/ReactTraining/react-router/blob/master/packages/react-router/modules/matchPath.js

var $6Wa8O = parcelRequire("6Wa8O");

const $e5f42900bd20f109$var$cache = {};
const $e5f42900bd20f109$var$cacheLimit = 10000;
let $e5f42900bd20f109$var$cacheCount = 0;
function $e5f42900bd20f109$var$compilePath(path, options) {
    const cacheKey = `${options.end}${options.strict}${options.sensitive}`;
    const pathCache = $e5f42900bd20f109$var$cache[cacheKey] || ($e5f42900bd20f109$var$cache[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    const keys = [];
    const regexp = (0, (/*@__PURE__*/$parcel$interopDefault($6Wa8O)))(path, keys, options);
    const result = {
        regexp: regexp,
        keys: keys
    };
    if ($e5f42900bd20f109$var$cacheCount < $e5f42900bd20f109$var$cacheLimit) {
        pathCache[path] = result;
        $e5f42900bd20f109$var$cacheCount++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 * TODO: reduce returns Array<never>
 */ function $e5f42900bd20f109$var$matchPath(pathname, options = {}) {
    if (typeof options === 'string' || Array.isArray(options)) options = {
        path: options
    };
    const { path: p, exact: exact = false, strict: strict = false, sensitive: sensitive = false, basePath: basePath = '' } = options;
    const paths = [].concat(basePath + p);
    return paths.reduce((matched, path)=>{
        if (!path && path !== '') return null;
        if (matched) return matched;
        const { regexp: regexp, keys: keys } = $e5f42900bd20f109$var$compilePath(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        });
        const match = regexp.exec(pathname);
        if (!match) return null;
        const [url, ...values] = match;
        const isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === '/' && url === '' ? '/' : url,
            isExact: // the matched portion of the URL
            isExact,
            // whether or not we matched exactly
            params: keys.reduce((memo, key, index)=>{
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
var $e5f42900bd20f109$export$2e2bcd8739ae039 = $e5f42900bd20f109$var$matchPath;
module.exports["default"] = $e5f42900bd20f109$export$2e2bcd8739ae039;

});

parcelRegister("6Wa8O", function(module, exports) {

var $fluH9 = parcelRequire("fluH9");

/**
 * Expose `pathToRegexp`.
 */ module.exports = $50d006a66fe8f078$var$pathToRegexp;
module.exports.parse = $50d006a66fe8f078$var$parse;
module.exports.compile = $50d006a66fe8f078$var$compile;
module.exports.tokensToFunction = $50d006a66fe8f078$var$tokensToFunction;
module.exports.tokensToRegExp = $50d006a66fe8f078$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $50d006a66fe8f078$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $50d006a66fe8f078$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;
    while((res = $50d006a66fe8f078$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = prefix || defaultDelimiter;
        var pattern = capture || group;
        var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
        tokens.push({
            name: name || key++,
            prefix: prefix || '',
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $50d006a66fe8f078$var$escapeGroup(pattern) : asterisk ? '.*' : $50d006a66fe8f078$var$restrictBacktrack(delimiter, prevText)
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
function $50d006a66fe8f078$var$restrictBacktrack(delimiter, prevText) {
    if (!prevText || prevText.indexOf(delimiter) > -1) return '[^' + $50d006a66fe8f078$var$escapeString(delimiter) + ']+?';
    return $50d006a66fe8f078$var$escapeString(prevText) + '|(?:(?!' + $50d006a66fe8f078$var$escapeString(prevText) + ')[^' + $50d006a66fe8f078$var$escapeString(delimiter) + '])+?';
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $50d006a66fe8f078$var$compile(str, options) {
    return $50d006a66fe8f078$var$tokensToFunction($50d006a66fe8f078$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $50d006a66fe8f078$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $50d006a66fe8f078$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $50d006a66fe8f078$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', $50d006a66fe8f078$var$flags(options));
    return function(obj, opts) {
        var path = '';
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $50d006a66fe8f078$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($fluH9(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $50d006a66fe8f078$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $50d006a66fe8f078$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $50d006a66fe8f078$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $50d006a66fe8f078$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $50d006a66fe8f078$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $50d006a66fe8f078$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $50d006a66fe8f078$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $50d006a66fe8f078$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($50d006a66fe8f078$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp('(?:' + parts.join('|') + ')', $50d006a66fe8f078$var$flags(options));
    return $50d006a66fe8f078$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $50d006a66fe8f078$var$stringToRegexp(path, keys, options) {
    return $50d006a66fe8f078$var$tokensToRegExp($50d006a66fe8f078$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $50d006a66fe8f078$var$tokensToRegExp(tokens, keys, options) {
    if (!$fluH9(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += $50d006a66fe8f078$var$escapeString(token);
        else {
            var prefix = $50d006a66fe8f078$var$escapeString(token.prefix);
            var capture = '(?:' + token.pattern + ')';
            keys.push(token);
            if (token.repeat) capture += '(?:' + prefix + capture + ')*';
            if (token.optional) {
                if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                else capture = prefix + '(' + capture + ')?';
            } else capture = prefix + '(' + capture + ')';
            route += capture;
        }
    }
    var delimiter = $50d006a66fe8f078$var$escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    if (end) route += '$';
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    return $50d006a66fe8f078$var$attachKeys(new RegExp('^' + route, $50d006a66fe8f078$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $50d006a66fe8f078$var$pathToRegexp(path, keys, options) {
    if (!$fluH9(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $50d006a66fe8f078$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($fluH9(path)) return $50d006a66fe8f078$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $50d006a66fe8f078$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}

});

parcelRegister("fluH9", function(module, exports) {
module.exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
};

});

parcelRegister("90bgH", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");

/**
 * Matches `queryStr` against config stored in `queryConfig`.
 *
 * Returns `pathMatch` with an additional query prop with query params if the match succeeds,
 * otherwise returns null.
 *
 */ function $68dcdad401c65436$var$matchQuery(queryConfig, queryParams, pathMatch) {
    const queryMatch = {};
    const isMatchingQuery = queryConfig.every((query)=>{
        // eslint-disable-next-line prefer-const
        let [names, value] = query.split('=');
        let negation = false;
        /* Check if negative matching query param (eg 'foo!=1') */ if (query.includes('!=')) {
            names = names.substring(0, names.length - 1);
            negation = true;
        }
        /* Allow alternate query params presence (eg 'foo|bar') */ const matched = names.split('|').map((name)=>{
            let isOptional = false;
            /* Check if optional query param (eg 'foo?') */ if (name.includes('?')) {
                // eslint-disable-next-line no-param-reassign
                name = name.substring(0, name.length - 1);
                isOptional = true;
            }
            /* First check if queryParams contains the relevant param */ let match = Object.prototype.hasOwnProperty.call(queryParams, name);
            /* Save actual value so we expose it as part of match object */ if (match) queryMatch[name] = queryParams[name] || '';
            /* If no value matching required or it is optional and the param is missing */ if (!value || isOptional && !match) return isOptional || match;
            if (value.startsWith('(')) /* Handle value being a regexp eg 's=(\\d+)' */ match = new RegExp(`^${value}$`).test(queryParams[name] || '');
            else /* Handle value exact matching eg 's=123' */ match = queryParams[name] === value;
            return negation ? !match : match;
        });
        /* If at least one of alternate query params matches then it is a match */ return matched.includes(true);
    });
    return isMatchingQuery ? (0, $7Q5yr.default)((0, $7Q5yr.default)({}, pathMatch), {}, {
        query: queryMatch
    }) : null;
}
var $68dcdad401c65436$export$2e2bcd8739ae039 = $68dcdad401c65436$var$matchQuery;
module.exports["default"] = $68dcdad401c65436$export$2e2bcd8739ae039;

});

parcelRegister("jwQ9Q", function(module, exports) {
const $e37976f0459cd6aa$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $e37976f0459cd6aa$var$MAX_CACHE_SIZE = 1000;
function $e37976f0459cd6aa$var$shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
     // Test for A's keys different from B.
    for(let i = 0; i < keysA.length; i++){
        if (!$e37976f0459cd6aa$var$hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
    }
    return true;
}
const $e37976f0459cd6aa$export$f594abf16a5ad948 = {
    cache: new Map(),
    get (pathname, queryObj, basePath) {
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) for (const [key, value] of pathCache){
            if ($e37976f0459cd6aa$var$shallowEqual(key, queryObj)) return value;
        }
    },
    set (pathname, queryObj, basePath, matchRoute) {
        if (this.cache.size > $e37976f0459cd6aa$var$MAX_CACHE_SIZE) this.cache.clear();
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) {
            if (pathCache.size > $e37976f0459cd6aa$var$MAX_CACHE_SIZE / 10) pathCache.clear();
            pathCache.set(queryObj, matchRoute);
        } else this.cache.set(basePath + pathname, new Map([
            [
                queryObj,
                matchRoute
            ]
        ]));
    }
};
module.exports["matchRouteCache"] = $e37976f0459cd6aa$export$f594abf16a5ad948;

});

parcelRegister("6di1Y", function(module, exports) {

var $6Wa8O = parcelRequire("6Wa8O");

const $4861f18396ddb853$var$generatePath = (pattern = '/', params)=>pattern === '/' ? pattern : (0, (/*@__PURE__*/$parcel$interopDefault($6Wa8O))).compile(pattern)(params);
var $4861f18396ddb853$export$2e2bcd8739ae039 = $4861f18396ddb853$var$generatePath;
module.exports["default"] = $4861f18396ddb853$export$2e2bcd8739ae039;

});

parcelRegister("jO7cU", function(module, exports) {

var $6Wa8O = parcelRequire("6Wa8O");


var $jBvme = parcelRequire("jBvme");

function $e6b84704b2d2308a$export$37e0729cc751960b(pattern = '/', options = {}) {
    const { params: params = {}, query: query = {}, basePath: basePath = '' } = options; // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $jBvme.qs).stringify(query, true);
    const pathname = pattern === '/' ? pattern : (0, (/*@__PURE__*/$parcel$interopDefault($6Wa8O))).compile(pattern)(params);
    return {
        pathname: `${basePath}${pathname}`,
        search: stringifiedQuery,
        hash: ''
    };
}
module.exports["generateLocationFromPath"] = $e6b84704b2d2308a$export$37e0729cc751960b;

});

parcelRegister("bx92O", function(module, exports) {
/**
 * @see https://github.com/jsdom/jsdom/releases/tag/12.0.0
 * @see https://github.com/jsdom/jsdom/issues/1537
 */ 
var $kyRHQ = parcelRequire("kyRHQ");

const $8659cac973488ab8$var$isJsDomEnvironment = ()=>window.name === 'nodejs' || navigator.userAgent.includes('Node.js') || navigator.userAgent.includes('jsdom');
const $8659cac973488ab8$export$455cc18296abe008 = ()=>{
    if (typeof $kyRHQ !== 'undefined' && $kyRHQ.versions != null && $kyRHQ.versions.node != null) return true;
    if ($8659cac973488ab8$var$isJsDomEnvironment()) return true;
    return false;
};
module.exports["isServerEnvironment"] = $8659cac973488ab8$export$455cc18296abe008;

});

parcelRegister("8hLIT", function(module, exports) {

var $jBvme = parcelRequire("jBvme");


var $lxnII = parcelRequire("lxnII");


var $jxSMo = parcelRequire("jxSMo");


var $6di1Y = parcelRequire("6di1Y");

const $6084ee0c165f4382$export$faed15f35ddc6f99 = (route, options = {})=>{
    const { params: params = {}, query: query = {}, basePath: basePath = '' } = options;
    const pathname = (0, $6di1Y.default)(route.path, params);
    const matchedRoute = (0, $jxSMo.default)([
        route
    ], pathname, query, basePath);
    return {
        route: route,
        match: matchedRoute ? matchedRoute.match : (0, $lxnII.DEFAULT_MATCH),
        query: query
    };
};
const $6084ee0c165f4382$export$a0bd0313cbeabd49 = (routes, options)=>{
    const { location: location, basePath: basePath = '' } = options;
    const { pathname: pathname, search: search } = location;
    const query = (0, $jBvme.qs).parse(search);
    const matchedRoute = (0, $jxSMo.default)(routes, pathname, query, basePath);
    return {
        query: query,
        route: matchedRoute ? matchedRoute.route : (0, $lxnII.DEFAULT_ROUTE),
        match: matchedRoute ? matchedRoute.match : (0, $lxnII.DEFAULT_MATCH)
    };
};
module.exports["createRouterContext"] = $6084ee0c165f4382$export$faed15f35ddc6f99;
module.exports["findRouterContext"] = $6084ee0c165f4382$export$a0bd0313cbeabd49;

});

parcelRegister("5Ikq3", function(module, exports) {
$parcel$export(module.exports, "isExternalAbsolutePath", () => (parcelRequire("i6U7G")).isExternalAbsolutePath);
$parcel$export(module.exports, "getRelativePath", () => (parcelRequire("i6U7G")).getRelativePath);
$parcel$export(module.exports, "updateQueryParams", () => (parcelRequire("i6U7G")).updateQueryParams);
$parcel$export(module.exports, "getRelativeURLFromLocation", () => (parcelRequire("i6U7G")).getRelativeURLFromLocation);

var $i6U7G = parcelRequire("i6U7G");


});

parcelRegister("i6U7G", function(module, exports) {

var $jBvme = parcelRequire("jBvme");

const $d2f4525ae0b48bb1$var$stripTrailingSlash = (path)=>path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
const $d2f4525ae0b48bb1$var$addLeadingSlash = (path)=>path.charAt(0) === '/' ? path : '/' + path;
const $d2f4525ae0b48bb1$export$b8ce2e8154d1dff1 = (path, prefix = '')=>{
    if (prefix) {
        prefix = $d2f4525ae0b48bb1$var$stripTrailingSlash(prefix);
        prefix = $d2f4525ae0b48bb1$var$addLeadingSlash(prefix);
        path = $d2f4525ae0b48bb1$var$addLeadingSlash(path);
    }
    return prefix + path;
};
const $d2f4525ae0b48bb1$export$e83e3719fc818ee5 = (path)=>{
    const regex = new RegExp('^([a-z]+://|//)', 'i');
    return regex.test(path);
};
const $d2f4525ae0b48bb1$export$2fa6dede99f181e5 = (path)=>{
    if (typeof path !== 'string' || !$d2f4525ae0b48bb1$export$e83e3719fc818ee5(path)) return false;
    const pathHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($jBvme)))(path).hostname;
    const currentHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($jBvme)))(window.location.href).hostname;
    return pathHostname !== currentHostname;
};
const $d2f4525ae0b48bb1$export$ae9fda833d91ed65 = (path, prefix = '')=>{
    if (typeof path !== 'string') return path;
    if (!$d2f4525ae0b48bb1$export$e83e3719fc818ee5(path)) {
        path = $d2f4525ae0b48bb1$export$b8ce2e8154d1dff1(path, prefix);
        return path;
    }
    const url = new (0, (/*@__PURE__*/$parcel$interopDefault($jBvme)))(path);
    return `${url.pathname}${url.query}${url.hash}`;
};
const $d2f4525ae0b48bb1$export$92377f461a797888 = (location, query)=>{
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $jBvme.qs).stringify(query, true);
    return `${location.pathname}${stringifiedQuery}${location.hash}`;
};
const $d2f4525ae0b48bb1$export$9ae1c7c875ef309d = (location)=>{
    return `${location.pathname}${location.search}${location.hash}`;
};
module.exports["isExternalAbsolutePath"] = $d2f4525ae0b48bb1$export$2fa6dede99f181e5;
module.exports["getRelativePath"] = $d2f4525ae0b48bb1$export$ae9fda833d91ed65;
module.exports["updateQueryParams"] = $d2f4525ae0b48bb1$export$92377f461a797888;
module.exports["getRelativeURLFromLocation"] = $d2f4525ae0b48bb1$export$9ae1c7c875ef309d;

});

parcelRegister("baqAE", function(module, exports) {

var $bDniu = parcelRequire("bDniu");


var $42omo = parcelRequire("42omo");


var $lbfkG = parcelRequire("lbfkG");

const $8215411ddc19127d$export$672d721d310ff5f0 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lbfkG.RouterSubscriber), null, (state, _ref)=>{
        let { listen: listen } = _ref, actions = (0, $bDniu.default)(_ref, [
            "listen"
        ]);
        if (!state.unlisten && !state.isStatic) listen();
        return children(state, actions);
    });
module.exports["RouterSubscriber"] = $8215411ddc19127d$export$672d721d310ff5f0;

});

parcelRegister("2U2r8", function(module, exports) {

var $iLaQ6 = parcelRequire("iLaQ6");


var $42omo = parcelRequire("42omo");


var $lxnII = parcelRequire("lxnII");


var $lbfkG = parcelRequire("lbfkG");

class $21d2b3a0e3b723ca$export$55185c17a0fcbe46 extends (0, $42omo.Component) {
    componentDidMount() {
        if (!this.props.isStatic) {
            const state = (0, $lbfkG.getRouterState)();
            this.unlistenHistory = state.unlisten;
        }
    }
    /**
   * Ensures that the router store stops listening to history when the Router
   * is unmounted.
   */ componentWillUnmount() {
        if (this.unlistenHistory) this.unlistenHistory();
    }
    render() {
        const { children: children, routes: routes, history: history, initialRoute: initialRoute, isStatic: isStatic, isGlobal: isGlobal, basePath: basePath, resourceContext: resourceContext, resourceData: resourceData, onPrefetch: onPrefetch } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lbfkG.RouterContainer), {
            basePath: basePath,
            routes: routes,
            history: history,
            initialRoute: initialRoute,
            isStatic: isStatic,
            resourceContext: resourceContext,
            resourceData: resourceData,
            onPrefetch: onPrefetch,
            isGlobal: isGlobal
        }, children);
    }
    constructor(...args){
        super(...args);
        (0, $iLaQ6.default)(this, "unlistenHistory", null);
    }
}
(0, $iLaQ6.default)($21d2b3a0e3b723ca$export$55185c17a0fcbe46, "defaultProps", {
    isStatic: false,
    isGlobal: true,
    history: (0, $lxnII.DEFAULT_HISTORY)
});
module.exports["Router"] = $21d2b3a0e3b723ca$export$55185c17a0fcbe46;

});

parcelRegister("lO3qv", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");


var $42omo = parcelRequire("42omo");


var $fgJFQ = parcelRequire("fgJFQ");


var $2U2r8 = parcelRequire("2U2r8");

const $fe00ecea2d426ada$var$getRouterProps = (memoryRouterProps)=>{
    const { isStatic: isStatic = false, isGlobal: isGlobal = true, basePath: basePath, routes: routes, resourceData: resourceData, resourceContext: resourceContext } = memoryRouterProps;
    let routerProps = {
        basePath: basePath,
        routes: routes,
        isStatic: isStatic,
        isGlobal: isGlobal
    };
    if (resourceData) routerProps = (0, $7Q5yr.default)((0, $7Q5yr.default)({}, routerProps), {}, {
        resourceData: resourceData
    });
    if (resourceContext) routerProps = (0, $7Q5yr.default)((0, $7Q5yr.default)({}, routerProps), {}, {
        resourceContext: resourceContext
    });
    return routerProps;
};
const $fe00ecea2d426ada$export$ae46f04cfaffe093 = (props)=>{
    const { location: location, children: children } = props;
    const config = {};
    if (location) config.initialEntries = [
        location
    ];
    const history = (0, $fgJFQ.createMemoryHistory)(config);
    const routerProps = $fe00ecea2d426ada$var$getRouterProps(props);
    return(/*#__PURE__*/ // @ts-ignore suppress history will be overwritten warning
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2U2r8.Router), (0, $7Q5yr.default)({
        history: history
    }, routerProps), children));
};
module.exports["MemoryRouter"] = $fe00ecea2d426ada$export$ae46f04cfaffe093;

});

parcelRegister("dzuak", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");


var $bDniu = parcelRequire("bDniu");


var $42omo = parcelRequire("42omo");


var $fgJFQ = parcelRequire("fgJFQ");

parcelRequire("jpyKN");
var $fAndP = parcelRequire("fAndP");


var $lO3qv = parcelRequire("lO3qv");


var $45iAl = parcelRequire("45iAl");


var $lbfkG = parcelRequire("lbfkG");

const $9e15f17bcc346afb$export$cac06da4d76d935b = ({ location: location, routes: routes, children: children, basePath: basePath })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lO3qv.MemoryRouter), {
        location: location,
        routes: routes,
        basePath: basePath,
        isStatic: true
    }, children);
/**
 * The entry point for requesting resource data on the server.
 * Pass the result data into the router as a prop in order to hydrate it.
 * TODO: return type (see imports)
 */ $9e15f17bcc346afb$export$cac06da4d76d935b.requestResources = async (props)=>{
    const { bootstrapStore: bootstrapStore, requestRouteResources: requestRouteResources } = (0, $lbfkG.getRouterStore)().actions;
    const { location: location, timeout: timeout } = props, bootstrapProps = (0, $bDniu.default)(props, [
        "location",
        "timeout"
    ]);
    const initialEntries = [
        location
    ];
    const overrides = {
        history: (0, $fgJFQ.createMemoryHistory)({
            initialEntries: initialEntries
        }),
        location: (0, $fAndP.createLocation)(location),
        isStatic: true
    };
    bootstrapStore((0, $7Q5yr.default)((0, $7Q5yr.default)({}, bootstrapProps), overrides));
    await requestRouteResources({
        timeout: timeout,
        isStatic: true
    });
    return (0, $45iAl.getResourceStore)().actions.getSafeData();
};
$9e15f17bcc346afb$export$cac06da4d76d935b.addResourcesListener = (fn)=>(0, $45iAl.getResourceStore)().storeState.subscribe(fn);

});

parcelRegister("jpyKN", function(module, exports) {
$parcel$export(module.exports, "createLocation", () => (parcelRequire("fAndP")).createLocation);

var $fAndP = parcelRequire("fAndP");


});

parcelRegister("fAndP", function(module, exports) {

var $z3uU7 = parcelRequire("z3uU7");


var $2Ypk3 = parcelRequire("2Ypk3");

function $02ed9ddbd11cda17$export$90c043f1c57770b8(path = '') {
    const location = (0, $2Ypk3.parsePath)(path);
    location.pathname = (0, $z3uU7.decodePath)(location.pathname);
    return location;
}
module.exports["createLocation"] = $02ed9ddbd11cda17$export$90c043f1c57770b8;

});

parcelRegister("z3uU7", function(module, exports) {
class $0695fb855ee13385$var$DecodeUriError extends URIError {
    constructor(path){
        super(`Pathname ${path} could not be decoded. This is likely caused by an invalid percent-encoding.`);
    }
}
function $0695fb855ee13385$export$cd27bea214d030c2(path) {
    try {
        return decodeURI(path);
    } catch (e) {
        if (e instanceof URIError) throw new $0695fb855ee13385$var$DecodeUriError(path);
        else throw e;
    }
}
module.exports["decodePath"] = $0695fb855ee13385$export$cd27bea214d030c2;

});

parcelRegister("2Ypk3", function(module, exports) {

var $jBvme = parcelRequire("jBvme");

function $22a4d3db4f500732$export$8ccf933b0513f8d0(path) {
    const url = new (0, (/*@__PURE__*/$parcel$interopDefault($jBvme)))(path, 'ws://a.a');
    const isAbsolute = path.startsWith('/');
    const pathname = isAbsolute || url.pathname === '/' ? url.pathname : url.pathname.slice(1);
    return {
        pathname: pathname,
        search: url.query,
        hash: url.hash
    };
}
module.exports["parsePath"] = $22a4d3db4f500732$export$8ccf933b0513f8d0;

});

parcelRegister("d6UuE", function(module, exports) {

var $bDniu = parcelRequire("bDniu");


var $42omo = parcelRequire("42omo");


var $lbfkG = parcelRequire("lbfkG");

const $98b7a851f791b8ca$export$b371fa9cf762ad06 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lbfkG.RouterActionsSubscriber), null, (__, _ref)=>{
        let actions = (0, $bDniu.default)(_ref, [
            "bootstrapStore",
            "listen",
            "requestRouteResources"
        ]);
        return children(actions);
    });
$98b7a851f791b8ca$export$b371fa9cf762ad06.displayName = 'RouterActions';

});

parcelRegister("hYD0c", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");


var $iLaQ6 = parcelRequire("iLaQ6");


var $42omo = parcelRequire("42omo");


var $fgJFQ = parcelRequire("fgJFQ");


var $baqAE = parcelRequire("baqAE");

parcelRequire("eFXPq");
var $jO7cU = parcelRequire("jO7cU");

class $d1664b4e2f318f90$var$Redirector extends (0, $42omo.Component) {
    componentDidMount() {
        const { to: to, location: location, push: push, params: params, query: query, actions: actions } = this.props;
        const routeAttributes = {
            params: params,
            query: query,
            basePath: actions.getBasePath()
        };
        const newPath = typeof to === 'object' ? 'path' in to ? (0, $fgJFQ.createPath)((0, $jO7cU.generateLocationFromPath)(to.path, routeAttributes)) : (0, $fgJFQ.createPath)(to) : to;
        const currentPath = (0, $fgJFQ.createPath)(location);
        const action = push ? actions.push : actions.replace;
        if (currentPath === newPath) return;
        action(newPath);
    }
    render() {
        return null;
    }
}
(0, $iLaQ6.default)($d1664b4e2f318f90$var$Redirector, "defaultProps", {
    push: false
});
const $d1664b4e2f318f90$export$2d8d895a0a0f636e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $baqAE.RouterSubscriber), null, ({ location: location }, actions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d1664b4e2f318f90$var$Redirector, (0, $7Q5yr.default)({
            actions: actions,
            location: location
        }, props)));

});

parcelRegister("dBql1", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");


var $42omo = parcelRequire("42omo");


var $baqAE = parcelRequire("baqAE");

const $9e732945f2295eaa$var$getWrappedComponentDisplayName = (component)=>{
    let componentDisplayName = 'UNDEFINED';
    const { displayName: displayName, name: name } = component;
    if (displayName) componentDisplayName = displayName;
    if (name) componentDisplayName = name;
    return `withRouter(${componentDisplayName})`;
};
const $9e732945f2295eaa$export$369b6b2b30582e8e = (WrappedComponent)=>{
    const displayName = $9e732945f2295eaa$var$getWrappedComponentDisplayName(WrappedComponent);
    const Component = WrappedComponent;
    const ComponentWithRouter = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $baqAE.RouterSubscriber), null, ({ route: route, location: location, query: query, match: match, action: action, history: history }, { push: push, replace: replace })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, (0, $7Q5yr.default)({}, props, {
                route: route,
                location: location,
                query: query,
                match: match,
                action: action,
                history: history,
                push: push,
                replace: replace
            })));
    ComponentWithRouter.displayName = displayName;
    return ComponentWithRouter;
};

});

parcelRegister("gE0ZU", function(module, exports) {
$parcel$export(module.exports, "useResource", () => (parcelRequire("cAkP0")).useResource);
$parcel$export(module.exports, "useRouter", () => (parcelRequire("bJu3R")).useRouter);
$parcel$export(module.exports, "useRouterActions", () => (parcelRequire("bJu3R")).useRouterActions);

var $cAkP0 = parcelRequire("cAkP0");


var $bJu3R = parcelRequire("bJu3R");


});

parcelRegister("bJu3R", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");


var $lbfkG = parcelRequire("lbfkG");

const $02344f57b941d8c5$export$9a302a45f65d0572 = ()=>{
    const [entireState, allActions] = (0, $lbfkG.useRouterStore)();
    return [
        entireState,
        allActions
    ];
};
const $02344f57b941d8c5$export$402e82ff1b20594b = ()=>{
    const [, allActions] = (0, $lbfkG.useRouterStoreStatic)();
    return allActions;
};
const $02344f57b941d8c5$var$createQueryParamHook = (0, $9zUhf.createHook)((0, $lbfkG.RouterStore), {
    selector: ({ query: query }, { paramKey: paramKey })=>query[paramKey]
});
const $02344f57b941d8c5$var$createPathParamHook = (0, $9zUhf.createHook)((0, $lbfkG.RouterStore), {
    selector: ({ match: { params: params } }, { paramKey: paramKey })=>params[paramKey]
});
const $02344f57b941d8c5$export$ae316f0eeb712a36 = (paramKey)=>{
    const [paramVal, routerActions] = $02344f57b941d8c5$var$createQueryParamHook({
        paramKey: paramKey
    });
    const setQueryParam = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((newValue, updateType)=>{
        routerActions.updateQueryParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setQueryParam
    ];
};
const $02344f57b941d8c5$export$8c8591dcd57728e6 = (paramKey)=>{
    const [paramVal, routerActions] = $02344f57b941d8c5$var$createPathParamHook({
        paramKey: paramKey
    });
    const setPathParam = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((newValue, updateType)=>{
        routerActions.updatePathParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setPathParam
    ];
};
module.exports["useRouter"] = $02344f57b941d8c5$export$9a302a45f65d0572;
module.exports["useRouterActions"] = $02344f57b941d8c5$export$402e82ff1b20594b;

});

parcelRegister("cRWzz", function(module, exports) {

var $4A54b = parcelRequire("4A54b");

/**
 * Utility method to created async versions of getData functions
 *
 */ const $95e7de947a25f8f8$var$handleGetDataLoader = (asyncImport)=>async (...args)=>{
        const { default: getDataFn } = await asyncImport();
        return getDataFn(...args);
    };
const $95e7de947a25f8f8$export$edd172c6c83c39cc = (arg)=>{
    var _getData, _arg$depends;
    return {
        type: arg.type,
        getKey: arg.getKey,
        getData: (_getData = arg.getData) != null ? _getData : $95e7de947a25f8f8$var$handleGetDataLoader(arg.getDataLoader),
        maxAge: typeof arg.maxAge === 'number' ? arg.maxAge : (0, $4A54b.DEFAULT_RESOURCE_MAX_AGE),
        maxCache: typeof arg.maxCache === 'number' ? arg.maxCache : (0, $4A54b.DEFAULT_CACHE_MAX_LIMIT),
        isBrowserOnly: typeof arg.isBrowserOnly === 'boolean' ? arg.isBrowserOnly : (0, $4A54b.DEFAULT_RESOURCE_BROWSER_ONLY),
        depends: (_arg$depends = arg.depends) != null ? _arg$depends : null
    };
};
module.exports["createResource"] = $95e7de947a25f8f8$export$edd172c6c83c39cc;

});

parcelRegister("jtq3j", function(module, exports) {

var $crDmH = parcelRequire("crDmH");


var $9f15D = parcelRequire("9f15D");


});

parcelRegister("crDmH", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");


var $bDniu = parcelRequire("bDniu");


var $fgJFQ = parcelRequire("fgJFQ");


var $42omo = parcelRequire("42omo");

parcelRequire("eFXPq");
var $8hLIT = parcelRequire("8hLIT");
var $jO7cU = parcelRequire("jO7cU");


var $lbfkG = parcelRequire("lbfkG");

parcelRequire("fd2Wo");
var $cxsu4 = parcelRequire("cxsu4");
var $9jfTo = parcelRequire("9jfTo");

const $90f68ac3c089e3fe$var$PREFETCH_DELAY = 300;
const $90f68ac3c089e3fe$var$Link = (0, $42omo.forwardRef)((_ref, ref)=>{
    let { children: children, target: target = '_self', replace: replace = false, href: href, to: to, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, type: linkType = 'a', params: params, query: query, prefetch: prefetch = false } = _ref, rest = (0, $bDniu.default)(_ref, [
        "children",
        "target",
        "replace",
        "href",
        "to",
        "onClick",
        "onMouseEnter",
        "onMouseLeave",
        "type",
        "params",
        "query",
        "prefetch"
    ]);
    const routerActions = (0, $lbfkG.useRouterStoreStatic)()[1];
    const prefetchRef = (0, $42omo.useRef)();
    const validLinkType = (0, $cxsu4.getValidLinkType)(linkType);
    const [route, setRoute] = (0, $42omo.useState)(()=>{
        if (to && typeof to !== 'string') {
            if ('then' in to) to.then((r)=>setRoute('default' in r ? r.default : r));
            else return to;
        }
    });
    const routeAttributes = {
        params: params,
        query: query,
        basePath: routerActions.getBasePath()
    };
    const linkDestination = href != null ? href : typeof to !== 'string' ? route && (0, $fgJFQ.createPath)((0, $jO7cU.generateLocationFromPath)(route.path, routeAttributes)) || '' : to;
    const triggerPrefetch = (0, $42omo.useCallback)(()=>{
        prefetchRef.current = undefined; // ignore if async route not ready yet
        if (typeof to !== 'string' && !route) return;
        const context = typeof to !== 'string' && route ? (0, $8hLIT.createRouterContext)(route, {
            params: params,
            query: query
        }) : null;
        routerActions.prefetchNextRouteResources(linkDestination, context); // omit params & query as already in linkDestination
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        route,
        linkDestination,
        routerActions
    ]);
    (0, $42omo.useEffect)(()=>{
        let timeout;
        if (prefetch === 'mount') timeout = setTimeout(triggerPrefetch, $90f68ac3c089e3fe$var$PREFETCH_DELAY);
        return ()=>clearTimeout(timeout);
    }, [
        prefetch,
        triggerPrefetch
    ]);
    const handleLinkPress = (e)=>(0, $9jfTo.handleNavigation)(e, {
            onClick: onClick,
            target: target,
            replace: replace,
            routerActions: routerActions,
            href: linkDestination,
            to: route && [
                route,
                {
                    params: params,
                    query: query
                }
            ]
        });
    const handleMouseEnter = (e)=>{
        if (prefetch === 'hover') prefetchRef.current = setTimeout(triggerPrefetch, $90f68ac3c089e3fe$var$PREFETCH_DELAY);
        onMouseEnter && onMouseEnter(e);
    };
    const handleMouseLeave = (e)=>{
        if (prefetch === 'hover' && prefetchRef.current) {
            clearTimeout(prefetchRef.current);
            prefetchRef.current = undefined;
        }
        onMouseLeave && onMouseLeave(e);
    };
    return (0, $42omo.createElement)(validLinkType, (0, $7Q5yr.default)((0, $7Q5yr.default)({}, rest), {}, {
        href: linkDestination,
        target: target,
        onClick: handleLinkPress,
        onKeyDown: handleLinkPress,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        ref: ref
    }), children);
});
$90f68ac3c089e3fe$var$Link.displayName = 'Link';
var $90f68ac3c089e3fe$export$2e2bcd8739ae039 = $90f68ac3c089e3fe$var$Link;

});

parcelRegister("fd2Wo", function(module, exports) {
$parcel$export(module.exports, "getValidLinkType", () => (parcelRequire("cxsu4")).getValidLinkType);
$parcel$export(module.exports, "handleNavigation", () => (parcelRequire("9jfTo")).handleNavigation);

var $cxsu4 = parcelRequire("cxsu4");


var $9jfTo = parcelRequire("9jfTo");


});

parcelRegister("cxsu4", function(module, exports) {
const $920ea96e665ab719$var$VALID_LINK_TYPES = [
    'a',
    'button'
];
const $920ea96e665ab719$export$855ece989b15eb57 = (type)=>$920ea96e665ab719$var$VALID_LINK_TYPES.includes(type) ? type : 'a';
module.exports["getValidLinkType"] = $920ea96e665ab719$export$855ece989b15eb57;

});

parcelRegister("9jfTo", function(module, exports) {

var $lAx2y = parcelRequire("lAx2y");

const $6c723753653be031$export$706ad1af8096e280 = (event, { onClick: onClick, target: target, replace: replace, routerActions: routerActions, href: href, to: to })=>{
    if ((0, $lAx2y.isKeyboardEvent)(event) && event.keyCode !== 13) return;
    onClick && onClick(event);
    if (!event.defaultPrevented && ((0, $lAx2y.isKeyboardEvent)(event) && event.keyCode === 13 || event.button === 0) && (!target || target === '_self') && // let browser handle "target=_blank" etc.
    !(0, $lAx2y.isModifiedEvent)(event) // ignore clicks with modifier keys
    ) {
        event.preventDefault();
        if (to) {
            const method = replace ? routerActions.replaceTo : routerActions.pushTo;
            method(...to);
        } else {
            const method = replace ? routerActions.replace : routerActions.push;
            method(href);
        }
    }
};
module.exports["handleNavigation"] = $6c723753653be031$export$706ad1af8096e280;

});

parcelRegister("lAx2y", function(module, exports) {
const $fb7696db560b3aad$export$642c6f14f6d4bbd5 = (event)=>!!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
const $fb7696db560b3aad$export$130b789831072f4c = (event)=>[
        'keypress',
        'keydown',
        'keyup'
    ].includes(event.type);
module.exports["isModifiedEvent"] = $fb7696db560b3aad$export$642c6f14f6d4bbd5;
module.exports["isKeyboardEvent"] = $fb7696db560b3aad$export$130b789831072f4c;

});

parcelRegister("9f15D", function(module, exports) {

var $42omo = parcelRequire("42omo");

parcelRequire("iOc92");
var $baqAE = parcelRequire("baqAE");

const $6ba65c322c4848e5$export$7903e4b73fc7d6c3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $baqAE.RouterSubscriber), null, ({ route: route, location: location, query: query, match: match, action: action })=>!route ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(route.component, {
            route: route,
            location: location,
            query: query,
            match: match,
            action: action
        }));

});

parcelRegister("fwXBL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::edc088c8e1dff28f4540e843bee097cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b4e8151e15b50def$var$_react = $b4e8151e15b50def$var$_interopRequireDefault((parcelRequire("42omo")));

var $b4e8151e15b50def$var$_baseNew = $b4e8151e15b50def$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $b4e8151e15b50def$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AssetsObject".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing objects in Assets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b4e8151e15b50def$var$AssetsObjectIcon = (props)=>/*#__PURE__*/ $b4e8151e15b50def$var$_react.default.createElement($b4e8151e15b50def$var$_baseNew.default, Object.assign({
        name: "AssetsObjectIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 3a.5.5 0 0 0-.5-.5h-2.5v3.75a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75V2.5H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM7 5.5h2v-3H7zm8 7.5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>`
    }, props));
$b4e8151e15b50def$var$AssetsObjectIcon.displayName = 'AssetsObjectIcon';
var $b4e8151e15b50def$var$_default = module.exports.default = $b4e8151e15b50def$var$AssetsObjectIcon;

});

parcelRegister("aH9Q1", function(module, exports) {

var $2xciB = parcelRequire("2xciB");


var $58Nu8 = parcelRequire("58Nu8");


var $56LFI = parcelRequire("56LFI");

const $da1a55ed1292d791$var$cache = (0, $2xciB.createCache)(new Map());
/** Message when a string path reaches runtime (expected: build rewrites it to a loader). */ const $da1a55ed1292d791$var$RUNTIME_STRING_ERROR = "JSResourceForInteraction was called with a string path at runtime. Ensure @atlassian/react-async-transformer is applied to transform this to a dynamic import.";
function $da1a55ed1292d791$export$e83743682263315a(loaderOrPath, opts) {
    if (typeof loaderOrPath === 'string') throw new Error(`${$da1a55ed1292d791$var$RUNTIME_STRING_ERROR} String path: ${JSON.stringify(loaderOrPath)}`);
    return $da1a55ed1292d791$var$cache.get(opts.moduleId, ()=>(0, $58Nu8.PreloadableJSResource)(()=>(0, $56LFI.postTask)(loaderOrPath, {
                priority: 'user-visible'
            }), opts));
}
module.exports["JSResourceForInteraction"] = $da1a55ed1292d791$export$e83743682263315a;

});

parcelRegister("2xciB", function(module, exports) {
function $148a59911478cb25$export$cf6fa0bbcc94b912(store) {
    return {
        get (key, supplier) {
            const value = store.get(key);
            if (value != null) return value;
            const v = supplier();
            store.set(key, v);
            return v;
        }
    };
}
module.exports["createCache"] = $148a59911478cb25$export$cf6fa0bbcc94b912;

});

parcelRegister("58Nu8", function(module, exports) {

var $2X3nY = parcelRequire("2X3nY");

function $ba332286d251cd41$export$4fe5fba5bb1d3c09(loader, opts) {
    const resource = (0, $2X3nY.JSResource)(loader, opts);
    return Object.assign(resource, {
        preload () {
            const jsModule = resource.getModuleIfRequired();
            if (jsModule != null) return;
            resource.load().catch(()=>{});
        }
    });
}
module.exports["PreloadableJSResource"] = $ba332286d251cd41$export$4fe5fba5bb1d3c09;

});

parcelRegister("2X3nY", function(module, exports) {

var $6hmze = parcelRequire("6hmze");


var $cAXnn = parcelRequire("cAXnn");


var $7Z6yP = parcelRequire("7Z6yP");

function $39dd57c545107221$export$148e45a6d4b4d65(loader, opts) {
    const { moduleId: moduleId, moduleName: moduleName, modulePath: modulePath, priority: priority } = opts;
    const listeners = new Set();
    let promise;
    let state = {
        type: 'init'
    };
    function createOnLoad(event) {
        return (module)=>{
            (0, $cAXnn.eventEmitter).emit('jsresource.load.complete', event);
            state = {
                type: 'module',
                module: module
            };
            for (const listener of listeners)listener.onLoad(module);
        };
    }
    function createOnError(event) {
        return (error)=>{
            (0, $cAXnn.eventEmitter).emit('jsresource.load.error', {
                ...event,
                error: error
            });
            state = {
                type: 'error',
                error: error
            };
            for (const listener of listeners)listener.onError?.(error);
        };
    }
    return {
        getModuleId () {
            return moduleId;
        },
        getModuleName () {
            return moduleName;
        },
        getModulePath () {
            return modulePath;
        },
        getPriority () {
            return priority;
        },
        getModuleIfRequired () {
            if (state.type === 'error') throw state.error;
            return state.type === 'module' ? state.module : null;
        },
        load () {
            if (!promise) {
                const event = {
                    moduleId: moduleId,
                    transactionId: (0, $6hmze.generateId)()
                };
                const onError = createOnError(event);
                const onLoad = createOnLoad(event);
                (0, $cAXnn.eventEmitter).emit('jsresource.load.start', event);
                try {
                    promise = loader().then((result)=>{
                        const module = (0, $7Z6yP.isJSModuleWithDefaultExport)(result) ? result.default : result;
                        onLoad(module);
                        return module;
                    }).catch((error)=>{
                        onError(error);
                        throw error;
                    });
                } catch (error) {
                    if (error instanceof Error) onError(error);
                    promise = Promise.reject(error);
                }
            }
            return promise;
        },
        onComplete (onLoad, onError) {
            if (state.type === 'module') {
                onLoad(state.module);
                return ()=>{};
            }
            if (state.type === 'error') {
                onError?.(state.error);
                return ()=>{};
            }
            const listener = {
                onError: onError,
                onLoad: onLoad
            };
            listeners.add(listener);
            return ()=>{
                listeners.delete(listener);
            };
        }
    };
}
module.exports["JSResource"] = $39dd57c545107221$export$148e45a6d4b4d65;

});

parcelRegister("6hmze", function(module, exports) {
let $546b0d6600b43919$var$id = 100000;
function $546b0d6600b43919$export$567fc7097e064344() {
    $546b0d6600b43919$var$id += 1;
    return $546b0d6600b43919$var$id.toString();
}
module.exports["generateId"] = $546b0d6600b43919$export$567fc7097e064344;

});

parcelRegister("cAXnn", function(module, exports) {
function $df7beae67697fe3a$var$createEventEmitter() {
    const eventSubscribers = new Map();
    return {
        emit (eventName, event) {
            const subscribers = eventSubscribers.get(eventName);
            for (const subscriber of subscribers ?? [])subscriber(event);
        },
        on (eventName, subscriber) {
            if (!eventSubscribers.has(eventName)) eventSubscribers.set(eventName, new Set([
                subscriber
            ]));
            else eventSubscribers.get(eventName).add(subscriber);
            return ()=>{
                const set = eventSubscribers.get(eventName);
                set.delete(subscriber);
                if (set.size === 0) eventSubscribers.delete(eventName);
            };
        }
    };
}
const $df7beae67697fe3a$export$10dc3edfc20c8ff = $df7beae67697fe3a$var$createEventEmitter();
module.exports["eventEmitter"] = $df7beae67697fe3a$export$10dc3edfc20c8ff;

});

parcelRegister("7Z6yP", function(module, exports) {
function $1cfe6d8b66e6a41d$export$3b514faac3ba993c(module) {
    try {
        // This should be replaced with Object.hasOwn once it is more widely supported
        return Object.prototype.hasOwnProperty.call(module, 'default');
    } catch (_) {
        // This fallback will occur when module is undefined, or null after converting to Object.hasOwn
        return false;
    }
}
module.exports["isJSModuleWithDefaultExport"] = $1cfe6d8b66e6a41d$export$3b514faac3ba993c;

});

parcelRegister("cab2i", function(module, exports) {
/* eslint-disable @typescript-eslint/ban-types */ function $991254190d627578$export$fa00dd5c1a75592f(// The param types can only be inferred if the shape of the entrypoint (i.e. root and getPreloadProps) is specified
// within the function definition itself. Using EntryPoint, EntryPointComponent, or a custom EntryPointRepresentation
// in place of this will cause Root to be inferred as an 'unknown' type.
params) {
    return params;
}
module.exports["createEntryPoint"] = $991254190d627578$export$fa00dd5c1a75592f;

});

parcelRegister("d4Pk4", function(module, exports) {

var $94jtO = parcelRequire("94jtO");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/platform/site/manifest.ts
var $985375b928439e07$var$platformSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $94jtO.PlatformSiteAriResourceOwner),
    resourceType: (0, $94jtO.PlatformSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/platform/site/index.ts
var $985375b928439e07$export$62388e9e87e2e1c9 = class _PlatformSiteAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $985375b928439e07$var$platformSiteAriStaticOpts.qualifier,
            platformQualifier: $985375b928439e07$var$platformSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $985375b928439e07$var$platformSiteAriStaticOpts.resourceOwner,
            resourceType: $985375b928439e07$var$platformSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $985375b928439e07$var$platformSiteAriStaticOpts);
        return new _PlatformSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $985375b928439e07$var$platformSiteAriStaticOpts);
        return new _PlatformSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
};
module.exports["PlatformSiteAri"] = $985375b928439e07$export$62388e9e87e2e1c9;

});

parcelRegister("94jtO", function(module, exports) {
// src/platform/site/types.ts
var $69a39916eb9c41be$export$2866935ccba4694c = "platform", $69a39916eb9c41be$export$c9ae8b227ea4b550 = "site";
module.exports["PlatformSiteAriResourceOwner"] = $69a39916eb9c41be$export$2866935ccba4694c;
module.exports["PlatformSiteAriResourceType"] = $69a39916eb9c41be$export$c9ae8b227ea4b550;

});

parcelRegister("9Omoq", function(module, exports) {

var $bMsrH = parcelRequire("bMsrH");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/townsquare/site/manifest.ts
var $724a275577bd8bbe$var$townsquareSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $bMsrH.TownsquareSiteAriResourceOwner),
    resourceType: (0, $bMsrH.TownsquareSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/townsquare/site/index.ts
var $724a275577bd8bbe$export$87ae3de5f1f7725a = class _TownsquareSiteAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $724a275577bd8bbe$var$townsquareSiteAriStaticOpts.qualifier,
            platformQualifier: $724a275577bd8bbe$var$townsquareSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $724a275577bd8bbe$var$townsquareSiteAriStaticOpts.resourceOwner,
            resourceType: $724a275577bd8bbe$var$townsquareSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $724a275577bd8bbe$var$townsquareSiteAriStaticOpts);
        return new _TownsquareSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $724a275577bd8bbe$var$townsquareSiteAriStaticOpts);
        return new _TownsquareSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
};
module.exports["TownsquareSiteAri"] = $724a275577bd8bbe$export$87ae3de5f1f7725a;

});

parcelRegister("bMsrH", function(module, exports) {
// src/townsquare/site/types.ts
var $893a3e20dd932982$export$9ee8c46ef1f3e6a8 = "townsquare", $893a3e20dd932982$export$44737bde24f3bac1 = "site";
module.exports["TownsquareSiteAriResourceOwner"] = $893a3e20dd932982$export$9ee8c46ef1f3e6a8;
module.exports["TownsquareSiteAriResourceType"] = $893a3e20dd932982$export$44737bde24f3bac1;

});

parcelRegister("4M6GB", function(module, exports) {

var $bniL1 = parcelRequire("bniL1");


var $hnvzE = parcelRequire("hnvzE");

const $a93efc0d5ccefe43$var$DefaultUFOSegmentComponent = (0, $hnvzE.default);
const $a93efc0d5ccefe43$var$entryPointConfig = {
    PlaceholderComponent: (0, $bniL1.default),
    UFOSegmentComponent: $a93efc0d5ccefe43$var$DefaultUFOSegmentComponent,
    ModalErrorFallback: ()=>null
};
function $a93efc0d5ccefe43$export$93a6801f9db838c4(overrides) {
    Object.assign($a93efc0d5ccefe43$var$entryPointConfig, overrides);
    return $a93efc0d5ccefe43$var$entryPointConfig;
}
function $a93efc0d5ccefe43$export$dfa96f26176fa91f() {
    return $a93efc0d5ccefe43$var$entryPointConfig;
}
module.exports["useEntryPointConfig"] = $a93efc0d5ccefe43$export$dfa96f26176fa91f;

});

parcelRegister("48FEk", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $irOoi = parcelRequire("irOoi");


var $eduVw = parcelRequire("eduVw");


var $hNKXO = parcelRequire("hNKXO");


var $4M6GB = parcelRequire("4M6GB");

function $f9885621a7911f5b$var$InternalEntryPointContainerInner({ entryPointReference: entryPointReference, errorFallback: errorFallback, /** Log and track errors */ onError: onErrorLocal, forcedError: forcedError, fallback: /** Loading fallback */ fallback, id: id, placeholderName: placeholderName, runtimeProps: runtimeProps }) {
    const { PlaceholderComponent: PlaceholderComponent } = (0, $4M6GB.useEntryPointConfig)();
    // useUFOReportError needs to be called under correct UFOSegment to work
    const reportErrorUFO = (0, $eduVw.useUFOReportError)();
    const onError = (0, $42omo.useCallback)((error, errorInfo)=>{
        onErrorLocal?.({
            error: error,
            errorInfo: errorInfo
        });
        (0, $hNKXO.reportError)({
            error: error,
            errorInfo: errorInfo,
            interactionId: id
        });
        reportErrorUFO({
            name: id,
            errorMessage: error?.message ?? 'Unknown error',
            errorStack: error?.stack ?? 'Unknown stack',
            forcedError: forcedError
        });
    }, [
        onErrorLocal,
        id,
        reportErrorUFO,
        forcedError
    ]);
    const FallbackComponent = (0, $42omo.useCallback)(({ error: error })=>{
        const onClose = runtimeProps?.onClose ?? (()=>{});
        return errorFallback ? errorFallback({
            error: error,
            onClose: onClose
        }) : null;
    }, [
        errorFallback,
        runtimeProps
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        FallbackComponent: FallbackComponent,
        onError: onError,
        children: /*#__PURE__*/ (0, $l998X.jsx)(PlaceholderComponent, {
            name: placeholderName ?? 'internal-internal-entry-point-container',
            fallback: fallback,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $irOoi.EntryPointContainer), {
                entryPointReference: entryPointReference,
                props: runtimeProps
            })
        })
    });
}
function $f9885621a7911f5b$export$5d4dc37edd8a3adb(props) {
    const { id: id } = props;
    const { UFOSegmentComponent: UFOSegmentComponent } = (0, $4M6GB.useEntryPointConfig)();
    return /*#__PURE__*/ (0, $l998X.jsx)(UFOSegmentComponent, {
        name: id,
        children: /*#__PURE__*/ (0, $l998X.jsx)($f9885621a7911f5b$var$InternalEntryPointContainerInner, {
            ...props
        })
    });
}
module.exports["InternalEntryPointContainer"] = $f9885621a7911f5b$export$5d4dc37edd8a3adb;

});

parcelRegister("hNKXO", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $e5b5ac7e446444f2$var$buffer = [];
let $e5b5ac7e446444f2$var$push = (payload)=>{
    $e5b5ac7e446444f2$var$buffer.push(payload);
};
function $e5b5ac7e446444f2$export$b33b857ad1d9900e(payload) {
    $e5b5ac7e446444f2$var$push(payload);
}
function $e5b5ac7e446444f2$export$abd5747ea77ecab9(handler) {
    if ((0, $dh538.fg)('moving_jira_entry-points_api_under_platform')) {
        $e5b5ac7e446444f2$var$push = handler;
        $e5b5ac7e446444f2$var$buffer.forEach((payload)=>handler(payload));
        $e5b5ac7e446444f2$var$buffer.length = 0;
    }
}
module.exports["reportError"] = $e5b5ac7e446444f2$export$b33b857ad1d9900e;

});

parcelRegister("1eBTN", function(module, exports) {

var $9Omoq = parcelRequire("9Omoq");

const $851240d1cd0bd23c$export$792aeacb7990bc6 = (containerId)=>{
    // we wrap in a try/catch incase there are any issues with creating the site ari
    try {
        return (0, $9Omoq.TownsquareSiteAri).create({
            siteId: containerId
        }).toString();
    } catch  {
        return '';
    }
};
module.exports["getSiteAri"] = $851240d1cd0bd23c$export$792aeacb7990bc6;

});

parcelRegister("eToX6", function(module, exports) {
/**
 * Utility functions for detecting and working with preview panels
 */ // Types for preview panel detection
// Preview panel indicators
const $cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS = {
    EMBEDDED_SOURCE: 'embeddedConfluenceSource',
    PREVIEW_PANELS: 'previewPanels',
    CONFLUENCE_PAGE_PREVIEW: 'confluence-page-preview-panel'
};
/**
 * Gets URL search parameters safely
 */ const $cf00e918e2c1556d$var$getUrlSearchParams = (url)=>{
    try {
        return new URLSearchParams(url);
    } catch  {
        return null;
    }
};
const $cf00e918e2c1556d$export$5c3b154013d00c5f = (searchParams)=>{
    return searchParams.has($cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS.PREVIEW_PANELS) || searchParams.get($cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS.EMBEDDED_SOURCE) === $cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS.CONFLUENCE_PAGE_PREVIEW;
};
const $cf00e918e2c1556d$export$cd88bef28d20da33 = ()=>{
    try {
        const currentSearch = window.location.search;
        if (currentSearch) {
            const currentParams = $cf00e918e2c1556d$var$getUrlSearchParams(currentSearch);
            if (currentParams && $cf00e918e2c1556d$export$5c3b154013d00c5f(currentParams)) return true;
        }
        return false;
    } catch  {
        return false;
    }
};
const $cf00e918e2c1556d$export$9f140ed41af5108c = ()=>{
    try {
        return window !== window.top;
    } catch  {
        // If we can't access window.top due to cross-origin restrictions, assume we're in an iframe
        return true;
    }
};
module.exports["hasPreviewPanelIndicators"] = $cf00e918e2c1556d$export$5c3b154013d00c5f;
module.exports["isInPreviewPanel"] = $cf00e918e2c1556d$export$cd88bef28d20da33;
module.exports["isInIframe"] = $cf00e918e2c1556d$export$9f140ed41af5108c;

});


$parcel$global.rlb("7sVIy")
//# sourceMappingURL=CommentEditor.baa94c28.js.map
